var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrosoftTechnology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 882.81 706.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:aqua;}.cls-3{fill:#f7fafb;}.cls-4{mix-blend-mode:multiply;}.cls-5{fill:#bdbfbd;}.cls-6{fill:#8e8e8d;}.cls-7{fill:#8d2d54;}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#New_Gradient_Swatch_15);}.cls-10{fill:url(#linear-gradient-2);}.cls-11{fill:url(#New_Gradient_Swatch_15-2);}.cls-12{fill:url(#linear-gradient-3);}.cls-13{fill:url(#New_Gradient_Swatch_15-3);}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#New_Gradient_Swatch_15-4);}.cls-16{fill:url(#linear-gradient-5);}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:url(#linear-gradient-8);}.cls-20{fill:url(#linear-gradient-9);}.cls-21{fill:url(#New_Gradient_Swatch_16);}.cls-22{fill:url(#linear-gradient-10);}.cls-23,.cls-24{opacity:0.3;}.cls-23,.cls-24,.cls-267,.cls-288,.cls-289{mix-blend-mode:screen;}.cls-23{fill:url(#linear-gradient-11);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{fill:url(#linear-gradient-13);}.cls-26{fill:url(#linear-gradient-14);}.cls-27{fill:url(#linear-gradient-15);}.cls-28{fill:url(#New_Gradient_Swatch_15-5);}.cls-29{fill:url(#linear-gradient-16);}.cls-30{fill:url(#linear-gradient-17);}.cls-31{fill:url(#linear-gradient-18);}.cls-32{fill:url(#linear-gradient-19);}.cls-33{fill:url(#linear-gradient-20);}.cls-34{fill:url(#linear-gradient-21);}.cls-35{fill:url(#linear-gradient-22);}.cls-36{fill:url(#linear-gradient-23);}.cls-37{fill:url(#linear-gradient-24);}.cls-38{fill:url(#linear-gradient-25);}.cls-39{fill:url(#linear-gradient-26);}.cls-40{fill:url(#linear-gradient-27);}.cls-41{fill:url(#linear-gradient-28);}.cls-42{fill:url(#linear-gradient-29);}.cls-43{fill:url(#linear-gradient-30);}.cls-44{fill:url(#linear-gradient-31);}.cls-45{fill:url(#linear-gradient-32);}.cls-46{fill:url(#linear-gradient-33);}.cls-47{fill:url(#linear-gradient-34);}.cls-48{fill:url(#linear-gradient-35);}.cls-49{fill:url(#linear-gradient-36);}.cls-50{fill:url(#linear-gradient-37);}.cls-51{fill:url(#linear-gradient-38);}.cls-52{fill:url(#linear-gradient-39);}.cls-53{fill:url(#linear-gradient-40);}.cls-54{fill:url(#linear-gradient-41);}.cls-55{fill:url(#linear-gradient-42);}.cls-56{fill:url(#linear-gradient-43);}.cls-57{fill:url(#linear-gradient-44);}.cls-58{fill:url(#linear-gradient-45);}.cls-59{fill:url(#linear-gradient-46);}.cls-60{fill:url(#linear-gradient-47);}.cls-61{fill:url(#linear-gradient-48);}.cls-62{fill:url(#linear-gradient-49);}.cls-63{fill:url(#linear-gradient-50);}.cls-64{fill:url(#linear-gradient-51);}.cls-65{fill:url(#linear-gradient-52);}.cls-66{fill:url(#linear-gradient-53);}.cls-67{fill:url(#linear-gradient-54);}.cls-68{fill:url(#linear-gradient-55);}.cls-69{fill:url(#linear-gradient-56);}.cls-70{fill:url(#linear-gradient-57);}.cls-71{fill:url(#linear-gradient-58);}.cls-72{fill:url(#linear-gradient-59);}.cls-73{fill:url(#linear-gradient-60);}.cls-74{fill:url(#linear-gradient-61);}.cls-75{fill:url(#linear-gradient-62);}.cls-76{fill:url(#linear-gradient-63);}.cls-77{fill:url(#linear-gradient-64);}.cls-78{fill:url(#linear-gradient-65);}.cls-79{fill:url(#linear-gradient-66);}.cls-80{fill:url(#linear-gradient-67);}.cls-81{fill:url(#linear-gradient-68);}.cls-82{fill:url(#linear-gradient-69);}.cls-83{fill:url(#linear-gradient-70);}.cls-84{fill:url(#linear-gradient-71);}.cls-85{fill:url(#linear-gradient-72);}.cls-86{fill:url(#linear-gradient-73);}.cls-87{fill:url(#linear-gradient-74);}.cls-88{fill:url(#linear-gradient-75);}.cls-89{fill:url(#linear-gradient-76);}.cls-90{fill:url(#linear-gradient-77);}.cls-91{fill:url(#linear-gradient-78);}.cls-92{fill:url(#linear-gradient-79);}.cls-93{fill:url(#linear-gradient-80);}.cls-94{fill:url(#linear-gradient-81);}.cls-95{fill:url(#linear-gradient-82);}.cls-96{fill:url(#linear-gradient-83);}.cls-97{fill:url(#linear-gradient-84);}.cls-98{fill:url(#linear-gradient-85);}.cls-99{fill:url(#linear-gradient-86);}.cls-100{fill:url(#linear-gradient-87);}.cls-101{fill:url(#linear-gradient-88);}.cls-102{fill:url(#linear-gradient-89);}.cls-103{fill:url(#linear-gradient-90);}.cls-104{fill:url(#linear-gradient-91);}.cls-105{fill:url(#linear-gradient-92);}.cls-106{fill:url(#linear-gradient-93);}.cls-107{fill:url(#linear-gradient-94);}.cls-108{fill:url(#linear-gradient-95);}.cls-109{fill:url(#linear-gradient-96);}.cls-110{fill:url(#linear-gradient-97);}.cls-111{fill:url(#linear-gradient-98);}.cls-112{fill:url(#linear-gradient-99);}.cls-113{fill:url(#linear-gradient-100);}.cls-114{fill:url(#linear-gradient-101);}.cls-115{fill:url(#linear-gradient-102);}.cls-116{fill:url(#linear-gradient-103);}.cls-117{fill:url(#linear-gradient-104);}.cls-118{fill:url(#linear-gradient-105);}.cls-119{fill:url(#linear-gradient-106);}.cls-120{fill:url(#linear-gradient-107);}.cls-121{fill:url(#linear-gradient-108);}.cls-122{fill:url(#linear-gradient-109);}.cls-123{fill:url(#linear-gradient-110);}.cls-124{fill:url(#linear-gradient-111);}.cls-125{fill:url(#linear-gradient-112);}.cls-126{fill:url(#linear-gradient-113);}.cls-127{fill:url(#linear-gradient-114);}.cls-128{fill:url(#linear-gradient-115);}.cls-129{fill:url(#linear-gradient-116);}.cls-130{fill:url(#linear-gradient-117);}.cls-131{fill:url(#linear-gradient-118);}.cls-132{fill:url(#linear-gradient-119);}.cls-133{fill:url(#linear-gradient-120);}.cls-134{fill:url(#linear-gradient-121);}.cls-135{fill:url(#linear-gradient-122);}.cls-136{fill:url(#linear-gradient-123);}.cls-137{fill:url(#linear-gradient-124);}.cls-138{fill:url(#linear-gradient-125);}.cls-139{fill:url(#linear-gradient-126);}.cls-140{fill:url(#linear-gradient-127);}.cls-141{fill:url(#linear-gradient-128);}.cls-142{fill:url(#linear-gradient-129);}.cls-143{fill:url(#linear-gradient-130);}.cls-144{fill:url(#linear-gradient-131);}.cls-145{fill:url(#linear-gradient-132);}.cls-146{fill:url(#linear-gradient-133);}.cls-147{fill:url(#linear-gradient-134);}.cls-148{fill:url(#linear-gradient-135);}.cls-149{fill:url(#linear-gradient-136);}.cls-150{fill:url(#linear-gradient-137);}.cls-151{fill:url(#linear-gradient-138);}.cls-152{fill:url(#linear-gradient-139);}.cls-153{fill:url(#linear-gradient-140);}.cls-154{fill:url(#linear-gradient-141);}.cls-155{fill:url(#linear-gradient-142);}.cls-156{fill:url(#linear-gradient-143);}.cls-157{fill:url(#linear-gradient-144);}.cls-158{fill:url(#linear-gradient-145);}.cls-159{fill:url(#linear-gradient-146);}.cls-160{fill:url(#linear-gradient-147);}.cls-161{fill:url(#linear-gradient-148);}.cls-162{fill:url(#linear-gradient-149);}.cls-163{fill:url(#linear-gradient-150);}.cls-164{fill:url(#linear-gradient-151);}.cls-165{fill:url(#linear-gradient-152);}.cls-166{fill:url(#linear-gradient-153);}.cls-167{fill:url(#linear-gradient-154);}.cls-168{fill:url(#linear-gradient-155);}.cls-169{fill:url(#linear-gradient-156);}.cls-170{fill:url(#linear-gradient-157);}.cls-171{fill:url(#linear-gradient-158);}.cls-172{fill:url(#linear-gradient-159);}.cls-173{fill:url(#linear-gradient-160);}.cls-174{fill:#0067c4;}.cls-175{fill:url(#New_Gradient_Swatch_15-6);}.cls-176{fill:url(#linear-gradient-161);}.cls-177{fill:url(#linear-gradient-162);}.cls-178{fill:url(#linear-gradient-163);}.cls-179{fill:url(#New_Gradient_Swatch_15-7);}.cls-180{fill:#ee0351;}.cls-181{fill:url(#linear-gradient-164);}.cls-182{fill:url(#linear-gradient-165);}.cls-183{fill:url(#New_Gradient_Swatch_16-2);}.cls-184{fill:url(#linear-gradient-166);}.cls-185{fill:url(#linear-gradient-167);}.cls-186{fill:#fdc6ad;}.cls-187{fill:url(#linear-gradient-168);}.cls-188{fill:#f5b297;}.cls-189{fill:url(#linear-gradient-169);}.cls-190{fill:url(#linear-gradient-170);}.cls-191{fill:#eae5d8;}.cls-192{fill:url(#linear-gradient-171);}.cls-193{fill:url(#linear-gradient-172);}.cls-194{fill:url(#linear-gradient-173);}.cls-195{fill:url(#linear-gradient-174);}.cls-196{fill:#ee8160;}.cls-197{fill:url(#New_Gradient_Swatch_16-3);}.cls-198{fill:url(#New_Gradient_Swatch_16-4);}.cls-199{fill:url(#New_Gradient_Swatch_16-5);}.cls-200{fill:url(#linear-gradient-175);}.cls-201{fill:url(#linear-gradient-176);}.cls-202{fill:url(#linear-gradient-177);}.cls-203{fill:url(#linear-gradient-178);}.cls-204{fill:url(#linear-gradient-179);}.cls-205{fill:url(#New_Gradient_Swatch_16-6);}.cls-206{fill:#dbd0bc;}.cls-207{fill:url(#linear-gradient-180);}.cls-208{fill:url(#linear-gradient-181);}.cls-209{fill:url(#linear-gradient-182);}.cls-210{fill:url(#linear-gradient-183);}.cls-211{fill:url(#linear-gradient-184);}.cls-212{fill:#fff;}.cls-213{fill:url(#linear-gradient-185);}.cls-214{fill:url(#linear-gradient-186);}.cls-215{fill:url(#linear-gradient-187);}.cls-216{fill:url(#linear-gradient-188);}.cls-217{fill:url(#linear-gradient-189);}.cls-218{fill:url(#linear-gradient-190);}.cls-219{fill:url(#linear-gradient-191);}.cls-220{fill:url(#linear-gradient-192);}.cls-221{fill:url(#New_Gradient_Swatch_16-7);}.cls-222{fill:url(#New_Gradient_Swatch_16-8);}.cls-223{fill:#bdbdbd;}.cls-224{fill:#b9b0a0;}.cls-225{fill:url(#linear-gradient-193);}.cls-226{fill:url(#linear-gradient-194);}.cls-227{fill:url(#New_Gradient_Swatch_15-8);}.cls-228{fill:#f9ae3b;}.cls-229{fill:url(#linear-gradient-195);}.cls-230{fill:#0b0a0c;}.cls-231{fill:url(#linear-gradient-196);}.cls-232{fill:url(#linear-gradient-197);}.cls-233{fill:url(#linear-gradient-198);}.cls-234{fill:url(#linear-gradient-199);}.cls-235{fill:url(#linear-gradient-200);}.cls-236{fill:url(#linear-gradient-201);}.cls-237{fill:#fbfbfb;}.cls-238{fill:url(#linear-gradient-202);}.cls-239{fill:#d5d4d3;}.cls-240{fill:url(#linear-gradient-203);}.cls-241{fill:url(#linear-gradient-204);}.cls-242{fill:url(#linear-gradient-205);}.cls-243{fill:url(#linear-gradient-206);}.cls-244{fill:url(#linear-gradient-207);}.cls-245{fill:url(#linear-gradient-208);}.cls-246{fill:url(#linear-gradient-209);}.cls-247{fill:url(#linear-gradient-210);}.cls-248{fill:url(#linear-gradient-211);}.cls-249{fill:url(#linear-gradient-212);}.cls-250{fill:url(#linear-gradient-213);}.cls-251{fill:url(#New_Gradient_Swatch_15-9);}.cls-252{fill:url(#linear-gradient-214);}.cls-253{fill:url(#linear-gradient-215);}.cls-254{fill:url(#linear-gradient-216);}.cls-255{fill:url(#linear-gradient-217);}.cls-256{fill:url(#linear-gradient-218);}.cls-257{fill:url(#linear-gradient-219);}.cls-258{fill:#f86564;}.cls-259{fill:url(#linear-gradient-220);}.cls-260{fill:url(#linear-gradient-221);}.cls-261{fill:url(#linear-gradient-222);}.cls-262{fill:url(#linear-gradient-223);}.cls-263{fill:url(#linear-gradient-224);}.cls-264{fill:url(#linear-gradient-225);}.cls-265{fill:url(#linear-gradient-226);}.cls-266{fill:url(#New_Gradient_Swatch_16-9);}.cls-268{fill:url(#New_Gradient_Swatch_16-10);}.cls-269{fill:url(#New_Gradient_Swatch_16-11);}.cls-270{fill:url(#linear-gradient-227);}.cls-271{fill:url(#New_Gradient_Swatch_16-12);}.cls-272{fill:url(#New_Gradient_Swatch_16-13);}.cls-273{fill:url(#New_Gradient_Swatch_16-14);}.cls-274{fill:url(#New_Gradient_Swatch_16-15);}.cls-275{fill:url(#New_Gradient_Swatch_16-16);}.cls-276{fill:url(#New_Gradient_Swatch_16-17);}.cls-277{fill:url(#New_Gradient_Swatch_16-18);}.cls-278{fill:url(#New_Gradient_Swatch_16-19);}.cls-279{fill:url(#New_Gradient_Swatch_16-20);}.cls-280{fill:#59595b;}.cls-281{fill:#808083;}.cls-282{fill:#919395;}.cls-283{fill:url(#linear-gradient-228);}.cls-284{fill:url(#linear-gradient-229);}.cls-285{fill:#e7e3d7;}.cls-286{fill:#f8f6f5;}.cls-287{fill:url(#linear-gradient-230);}.cls-288,.cls-289{opacity:0.2;}.cls-288{fill:url(#linear-gradient-231);}.cls-289{fill:url(#linear-gradient-232);}.cls-290{fill:#ffa000;}.cls-291{fill:url(#linear-gradient-233);}.cls-292{fill:#fa8c00;}.cls-293{fill:url(#linear-gradient-234);}.cls-294{fill:#ff6300;}.cls-295{fill:#ffb017;}.cls-296{fill:url(#New_Gradient_Swatch_15-10);}.cls-297{fill:#009ae5;}.cls-298{fill:#ff475c;}.cls-299{fill:url(#linear-gradient-235);}.cls-300{fill:url(#linear-gradient-236);}.cls-301{fill:url(#New_Gradient_Swatch_15-11);}.cls-302{fill:#f55000;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 308.18,
    y1: 270.5,
    x2: 376.02,
    y2: 270.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91cbeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15",
    x1: 330.08,
    y1: 227.05,
    x2: 354.04,
    y2: 268.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deeef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bddff2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 253.96,
    y1: 299.69,
    x2: 321.8,
    y2: 299.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15-2",
    x1: 275.86,
    y1: 256.24,
    x2: 299.82,
    y2: 297.73,
    xlinkHref: "#New_Gradient_Swatch_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 361.56,
    y1: 304.02,
    x2: 429.39,
    y2: 304.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15-3",
    x1: 383.46,
    y1: 260.57,
    x2: 407.41,
    y2: 302.06,
    xlinkHref: "#New_Gradient_Swatch_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 307.33,
    y1: 333.2,
    x2: 375.17,
    y2: 333.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15-4",
    x1: 329.24,
    y1: 289.75,
    x2: 353.19,
    y2: 331.25,
    xlinkHref: "#New_Gradient_Swatch_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 754.05,
    y1: 434.66,
    x2: 765.99,
    y2: 434.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfe0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91cbeb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 491.61,
    y1: 88.6,
    x2: 507.45,
    y2: 88.6,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 693.09,
    y1: 429.73,
    x2: 693.09,
    y2: 243.1,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 429.52,
    y1: 161.35,
    x2: 688.55,
    y2: 161.35,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 748.03,
    y1: 241.47,
    x2: 766.5,
    y2: 241.47,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16",
    x1: 558.27,
    y1: 153.98,
    x2: 704.76,
    y2: 407.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#384b57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b0a0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 428.99,
    y1: 265.78,
    x2: 679.27,
    y2: 265.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0067c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 451.93,
    y1: 134.55,
    x2: 510.65,
    y2: 359.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#029de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0571ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 528.85,
    y1: 155.03,
    x2: 585.29,
    y2: 371.37,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 746.4,
    y1: 447.89,
    x2: 752.37,
    y2: 458.24,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 521.2,
    y1: 501.51,
    x2: 678.81,
    y2: 501.51,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 317.74,
    y1: 473.59,
    x2: 589.93,
    y2: 473.59,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15-5",
    x1: 479.9,
    y1: 324.08,
    x2: 568.19,
    y2: 477,
    xlinkHref: "#New_Gradient_Swatch_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 415.5,
    y1: 450.39,
    x2: 546.74,
    y2: 450.39,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 414.87,
    y1: 317.97,
    x2: 431.69,
    y2: 317.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27263f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1a1927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b0a0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 398.31,
    y1: 318.08,
    x2: 414.87,
    y2: 318.08,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 396.85,
    y1: 300.79,
    x2: 639.92,
    y2: 448.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54636d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22272b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 436.1,
    y1: 330.23,
    x2: 452.92,
    y2: 330.23,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 419.5,
    y1: 330.32,
    x2: 436.1,
    y2: 330.32,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 397.16,
    y1: 300.3,
    x2: 640.22,
    y2: 448.45,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 457.29,
    y1: 342.46,
    x2: 474.11,
    y2: 342.46,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 440.74,
    y1: 342.57,
    x2: 457.29,
    y2: 342.57,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 397.46,
    y1: 299.8,
    x2: 640.52,
    y2: 447.95,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 478.48,
    y1: 354.7,
    x2: 495.3,
    y2: 354.7,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 461.93,
    y1: 354.8,
    x2: 478.48,
    y2: 354.8,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 397.76,
    y1: 299.3,
    x2: 640.83,
    y2: 447.45,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 499.67,
    y1: 366.93,
    x2: 516.49,
    y2: 366.93,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 483.12,
    y1: 367.04,
    x2: 499.67,
    y2: 367.04,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 398.07,
    y1: 298.81,
    x2: 641.13,
    y2: 446.95,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 520.9,
    y1: 379.19,
    x2: 537.72,
    y2: 379.19,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 393.33,
    y1: 306.58,
    x2: 636.39,
    y2: 454.73,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 398.37,
    y1: 298.31,
    x2: 641.43,
    y2: 446.46,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 542.09,
    y1: 391.42,
    x2: 558.91,
    y2: 391.42,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 393.63,
    y1: 306.09,
    x2: 636.69,
    y2: 454.23,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 398.67,
    y1: 297.81,
    x2: 641.74,
    y2: 445.96,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 563.28,
    y1: 403.66,
    x2: 580.1,
    y2: 403.66,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 546.73,
    y1: 403.76,
    x2: 563.28,
    y2: 403.76,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 398.98,
    y1: 297.32,
    x2: 642.04,
    y2: 445.46,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 584.51,
    y1: 415.91,
    x2: 601.33,
    y2: 415.91,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 394.23,
    y1: 305.09,
    x2: 637.3,
    y2: 453.24,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 399.28,
    y1: 296.82,
    x2: 642.34,
    y2: 444.97,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 605.7,
    y1: 428.15,
    x2: 622.52,
    y2: 428.15,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 589.15,
    y1: 428.26,
    x2: 605.71,
    y2: 428.26,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 399.58,
    y1: 296.32,
    x2: 642.64,
    y2: 444.47,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 648.12,
    y1: 452.64,
    x2: 664.94,
    y2: 452.64,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 610.34,
    y1: 446.62,
    x2: 648.13,
    y2: 446.62,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 400.04,
    y1: 295.58,
    x2: 643.1,
    y2: 443.72,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 414.71,
    y1: 342.67,
    x2: 431.5,
    y2: 342.67,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 376.93,
    y1: 336.63,
    x2: 414.72,
    y2: 336.63,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 385.68,
    y1: 319.13,
    x2: 628.74,
    y2: 467.28,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 435.9,
    y1: 354.9,
    x2: 452.69,
    y2: 354.9,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 419.35,
    y1: 355,
    x2: 435.91,
    y2: 355,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 386.13,
    y1: 318.38,
    x2: 629.2,
    y2: 466.53,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 457.09,
    y1: 367.13,
    x2: 473.87,
    y2: 367.13,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 440.54,
    y1: 367.23,
    x2: 457.1,
    y2: 367.23,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 386.44,
    y1: 317.89,
    x2: 629.5,
    y2: 466.03,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 478.28,
    y1: 379.37,
    x2: 495.06,
    y2: 379.37,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 461.73,
    y1: 379.47,
    x2: 478.29,
    y2: 379.47,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 386.74,
    y1: 317.39,
    x2: 629.8,
    y2: 465.54,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 499.51,
    y1: 391.63,
    x2: 516.3,
    y2: 391.63,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 382.01,
    y1: 325.15,
    x2: 625.07,
    y2: 473.29,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 387.04,
    y1: 316.89,
    x2: 630.11,
    y2: 465.04,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 520.7,
    y1: 403.86,
    x2: 537.49,
    y2: 403.86,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 382.31,
    y1: 324.65,
    x2: 625.38,
    y2: 472.8,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 387.35,
    y1: 316.39,
    x2: 630.41,
    y2: 464.54,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 541.89,
    y1: 416.09,
    x2: 558.68,
    y2: 416.09,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 525.34,
    y1: 416.19,
    x2: 541.9,
    y2: 416.19,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 387.65,
    y1: 315.9,
    x2: 630.71,
    y2: 464.05,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 563.12,
    y1: 428.35,
    x2: 579.91,
    y2: 428.35,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 382.92,
    y1: 323.66,
    x2: 625.99,
    y2: 471.81,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 387.95,
    y1: 315.4,
    x2: 631.02,
    y2: 463.55,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 584.31,
    y1: 440.59,
    x2: 601.1,
    y2: 440.59,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 567.76,
    y1: 440.68,
    x2: 584.32,
    y2: 440.68,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 388.25,
    y1: 314.9,
    x2: 631.32,
    y2: 463.05,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 605.5,
    y1: 452.82,
    x2: 622.29,
    y2: 452.82,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 588.95,
    y1: 452.92,
    x2: 605.51,
    y2: 452.92,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 388.56,
    y1: 314.41,
    x2: 631.62,
    y2: 462.55,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 626.74,
    y1: 465.08,
    x2: 643.52,
    y2: 465.08,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 610.14,
    y1: 465.16,
    x2: 626.74,
    y2: 465.16,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 388.86,
    y1: 313.91,
    x2: 631.93,
    y2: 462.06,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 393.33,
    y1: 355.09,
    x2: 410.11,
    y2: 355.09,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 355.55,
    y1: 349.06,
    x2: 393.34,
    y2: 349.06,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 374.37,
    y1: 337.69,
    x2: 617.43,
    y2: 485.84,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 414.52,
    y1: 367.33,
    x2: 431.3,
    y2: 367.33,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 397.97,
    y1: 367.42,
    x2: 414.53,
    y2: 367.42,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 362.84,
    y1: 331.17,
    x2: 608.25,
    y2: 473.54,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 435.71,
    y1: 379.56,
    x2: 452.49,
    y2: 379.56,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 419.16,
    y1: 379.66,
    x2: 435.72,
    y2: 379.66,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 375.12,
    y1: 336.45,
    x2: 618.19,
    y2: 484.6,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 456.9,
    y1: 391.8,
    x2: 473.68,
    y2: 391.8,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 440.35,
    y1: 391.89,
    x2: 456.91,
    y2: 391.89,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 375.43,
    y1: 335.95,
    x2: 618.49,
    y2: 484.1,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 478.13,
    y1: 404.05,
    x2: 494.91,
    y2: 404.05,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 370.7,
    y1: 343.71,
    x2: 613.76,
    y2: 491.86,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 375.73,
    y1: 335.46,
    x2: 618.79,
    y2: 483.6,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 499.32,
    y1: 416.29,
    x2: 516.1,
    y2: 416.29,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 371,
    y1: 343.22,
    x2: 614.06,
    y2: 491.36,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 376.03,
    y1: 334.96,
    x2: 619.1,
    y2: 483.11,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 520.51,
    y1: 428.52,
    x2: 537.29,
    y2: 428.52,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 503.96,
    y1: 428.62,
    x2: 520.52,
    y2: 428.62,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 376.33,
    y1: 334.46,
    x2: 619.4,
    y2: 482.61,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 541.74,
    y1: 440.78,
    x2: 558.52,
    y2: 440.78,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 525.15,
    y1: 440.86,
    x2: 541.75,
    y2: 440.86,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 376.64,
    y1: 333.97,
    x2: 619.7,
    y2: 482.11,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 562.93,
    y1: 453.01,
    x2: 579.71,
    y2: 453.01,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 546.38,
    y1: 453.11,
    x2: 562.94,
    y2: 453.11,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 376.94,
    y1: 333.47,
    x2: 620,
    y2: 481.62,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 605.35,
    y1: 477.51,
    x2: 622.13,
    y2: 477.51,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 567.57,
    y1: 471.47,
    x2: 605.36,
    y2: 471.47,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 377.39,
    y1: 332.72,
    x2: 620.46,
    y2: 480.87,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 393.13,
    y1: 379.76,
    x2: 409.92,
    y2: 379.76,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 334.16,
    y1: 367.61,
    x2: 393.14,
    y2: 367.61,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 363.2,
    y1: 356.01,
    x2: 606.27,
    y2: 504.16,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 414.32,
    y1: 391.99,
    x2: 431.11,
    y2: 391.99,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 397.77,
    y1: 392.09,
    x2: 414.33,
    y2: 392.09,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 363.81,
    y1: 355.01,
    x2: 606.87,
    y2: 503.16,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 435.51,
    y1: 404.22,
    x2: 452.3,
    y2: 404.22,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 418.96,
    y1: 404.32,
    x2: 435.52,
    y2: 404.32,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 364.11,
    y1: 354.52,
    x2: 607.18,
    y2: 502.67,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 456.74,
    y1: 416.48,
    x2: 473.53,
    y2: 416.48,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 440.19,
    y1: 416.58,
    x2: 456.75,
    y2: 416.58,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 364.41,
    y1: 354.02,
    x2: 607.48,
    y2: 502.17,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 477.93,
    y1: 428.72,
    x2: 494.72,
    y2: 428.72,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 461.38,
    y1: 428.81,
    x2: 477.94,
    y2: 428.81,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 364.72,
    y1: 353.52,
    x2: 607.78,
    y2: 501.67,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 499.12,
    y1: 440.95,
    x2: 515.91,
    y2: 440.95,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 482.57,
    y1: 441.05,
    x2: 499.13,
    y2: 441.05,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 365.02,
    y1: 353.03,
    x2: 608.08,
    y2: 501.17,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 520.36,
    y1: 453.21,
    x2: 537.14,
    y2: 453.21,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 503.76,
    y1: 453.29,
    x2: 520.36,
    y2: 453.29,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 365.32,
    y1: 352.53,
    x2: 608.39,
    y2: 500.68,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 541.55,
    y1: 465.44,
    x2: 558.33,
    y2: 465.44,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 525,
    y1: 465.54,
    x2: 541.55,
    y2: 465.54,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 365.62,
    y1: 352.03,
    x2: 608.69,
    y2: 500.18,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 583.97,
    y1: 489.93,
    x2: 600.75,
    y2: 489.93,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 546.19,
    y1: 483.9,
    x2: 583.97,
    y2: 483.9,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 366.08,
    y1: 351.29,
    x2: 609.14,
    y2: 499.43,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 329.29,
    y1: 367.7,
    x2: 346.11,
    y2: 367.7,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 312.74,
    y1: 367.81,
    x2: 329.29,
    y2: 367.81,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 351.57,
    y1: 375.09,
    x2: 594.64,
    y2: 523.24,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 350.52,
    y1: 379.96,
    x2: 367.34,
    y2: 379.96,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 333.93,
    y1: 380.06,
    x2: 350.53,
    y2: 380.06,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 351.88,
    y1: 374.59,
    x2: 594.94,
    y2: 522.74,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 371.71,
    y1: 392.19,
    x2: 388.53,
    y2: 392.19,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 355.16,
    y1: 392.3,
    x2: 371.72,
    y2: 392.3,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 352.18,
    y1: 374.09,
    x2: 595.24,
    y2: 522.24,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 477.7,
    y1: 453.39,
    x2: 494.52,
    y2: 453.39,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 376.35,
    y1: 429.02,
    x2: 477.71,
    y2: 429.02,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 353.09,
    y1: 372.6,
    x2: 596.15,
    y2: 520.75,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 498.93,
    y1: 465.65,
    x2: 515.75,
    y2: 465.65,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 482.34,
    y1: 465.74,
    x2: 498.94,
    y2: 465.74,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 354,
    y1: 371.11,
    x2: 597.06,
    y2: 519.26,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 520.12,
    y1: 477.88,
    x2: 536.94,
    y2: 477.88,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 503.57,
    y1: 477.99,
    x2: 520.13,
    y2: 477.99,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 354.3,
    y1: 370.61,
    x2: 597.36,
    y2: 518.76,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 562.54,
    y1: 502.37,
    x2: 579.37,
    y2: 502.37,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 524.76,
    y1: 496.35,
    x2: 562.55,
    y2: 496.35,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 354.75,
    y1: 369.87,
    x2: 597.82,
    y2: 518.02,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15-6",
    x1: 542.95,
    y1: 230.78,
    x2: 586.31,
    y2: 305.89,
    xlinkHref: "#New_Gradient_Swatch_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 540.92,
    y1: 227.28,
    x2: 588.34,
    y2: 309.4,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 613.03,
    y1: 205.81,
    x2: 616.62,
    y2: 205.81,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 595.03,
    y1: 236.11,
    x2: 720.51,
    y2: 236.11,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15-7",
    x1: 594.81,
    y1: 284.35,
    x2: 720.46,
    y2: 284.35,
    xlinkHref: "#New_Gradient_Swatch_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 606.33,
    y1: 199.45,
    x2: 608.86,
    y2: 203.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f55000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 645.2,
    y1: 283.94,
    x2: 648.79,
    y2: 283.94,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-2",
    x1: 636.25,
    y1: 273.03,
    x2: 639.84,
    y2: 273.03,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 615.66,
    y1: 258.14,
    x2: 619.25,
    y2: 258.14,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 589.07,
    y1: 440.78,
    x2: 617.33,
    y2: 440.78,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 686.42,
    y1: 425.94,
    x2: 692.62,
    y2: 413.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c20351"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 695.4,
    y1: 527.82,
    x2: 696.68,
    y2: 465.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c8e5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8ac8e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71bce5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 714.07,
    y1: 539.16,
    x2: 705.52,
    y2: 448.95,
    xlinkHref: "#linear-gradient-169"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 706.01,
    y1: 398.41,
    x2: 703.23,
    y2: 449.29,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 683.22,
    y1: 539.25,
    x2: 702.13,
    y2: 539.25,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 703.84,
    y1: 550.93,
    x2: 714.42,
    y2: 550.93,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 722.2,
    y1: 436.73,
    x2: 715.36,
    y2: 407.02,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-3",
    x1: 696.2,
    y1: 388.97,
    x2: 717.69,
    y2: 388.97,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-4",
    x1: 694.43,
    y1: 369.86,
    x2: 708.27,
    y2: 369.86,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-5",
    x1: 693.22,
    y1: 386.53,
    x2: 699.69,
    y2: 386.53,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 387.77,
    y1: 528.06,
    x2: 411.71,
    y2: 528.06,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 402.17,
    y1: 538.19,
    x2: 429.02,
    y2: 538.19,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 387.27,
    y1: 482.33,
    x2: 406.47,
    y2: 482.33,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 398.4,
    y1: 488.86,
    x2: 422.43,
    y2: 488.86,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 384.69,
    y1: 380.83,
    x2: 420.92,
    y2: 443.56,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-6",
    x1: 393.64,
    y1: 361.24,
    x2: 417.69,
    y2: 361.24,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 416.75,
    y1: 403.5,
    x2: 437.66,
    y2: 439.73,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 402.7,
    y1: 373.31,
    x2: 410.59,
    y2: 386.99,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 354.21,
    y1: 190.6,
    x2: 345.71,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4911e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f27921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef5a24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 354.73,
    y1: 189.35,
    x2: 357.06,
    y2: 193.37,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 337.77,
    y1: 242.38,
    x2: 334.78,
    y2: 199.2,
    xlinkHref: "#linear-gradient-168"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 316.25,
    y1: 164.76,
    x2: 343.27,
    y2: 211.56,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 327.55,
    y1: 154.25,
    x2: 332.04,
    y2: 162.04,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 341.91,
    y1: 297.99,
    x2: 351.6,
    y2: 314.78,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 324.76,
    y1: 311.55,
    x2: 333.37,
    y2: 326.47,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 317.32,
    y1: 205.49,
    x2: 320.85,
    y2: 166.05,
    xlinkHref: "#linear-gradient-182"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 317.72,
    y1: 202.92,
    x2: 321.2,
    y2: 208.95,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 335.47,
    y1: 161.87,
    x2: 359.87,
    y2: 204.13,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 339.6,
    y1: 153.3,
    x2: 342.27,
    y2: 157.92,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-7",
    x1: 321.21,
    y1: 143.11,
    x2: 343.39,
    y2: 143.11,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-8",
    x1: 330.8,
    y1: 130.2,
    x2: 345.23,
    y2: 130.2,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 673.46,
    y1: 600.05,
    x2: 770.25,
    y2: 600.05,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 770.16,
    y1: 599.72,
    x2: 867.46,
    y2: 599.72,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15-8",
    x1: 673.57,
    y1: 555.77,
    x2: 867.46,
    y2: 555.77,
    xlinkHref: "#New_Gradient_Swatch_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 748.74,
    y1: 586.06,
    x2: 780.44,
    y2: 586.06,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 897.63,
    y1: 584.16,
    x2: 929.33,
    y2: 584.16,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 770.08,
    y1: 575.02,
    x2: 839.57,
    y2: 575.02,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 700.16,
    y1: 575.02,
    x2: 770.1,
    y2: 575.02,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 700.18,
    y1: 551.14,
    x2: 839.57,
    y2: 551.14,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 769.85,
    y1: 268.62,
    x2: 769.85,
    y2: 570.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#e8f6fc",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#adddf3",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4fb7e5",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ea9e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 887.01,
    y1: 68.16,
    x2: 887.01,
    y2: 209.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 1346.97, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 737.58,
    y1: 0,
    x2: 737.58,
    y2: 75.36,
    xlinkHref: "#linear-gradient-201"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 125.46,
    y1: 502.35,
    x2: 220.58,
    y2: 502.35,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 25.97,
    y1: 360.97,
    x2: 130.81,
    y2: 542.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91cbeb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 31.03,
    y1: 485.06,
    x2: 125.56,
    y2: 485.06,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 125.55,
    y1: 484.73,
    x2: 220.59,
    y2: 484.73,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 125.56,
    y1: 468.09,
    x2: 220.68,
    y2: 468.09,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 125.65,
    y1: 451.44,
    x2: 220.69,
    y2: 451.44,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 31.12,
    y1: 451.77,
    x2: 125.66,
    y2: 451.77,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 125.66,
    y1: 434.79,
    x2: 220.77,
    y2: 434.79,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 125.74,
    y1: 418.14,
    x2: 220.78,
    y2: 418.14,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 31.22,
    y1: 418.47,
    x2: 125.75,
    y2: 418.47,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 125.75,
    y1: 400.52,
    x2: 220.87,
    y2: 400.52,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15-9",
    x1: 102.39,
    y1: 316.49,
    x2: 149.8,
    y2: 398.62,
    xlinkHref: "#New_Gradient_Swatch_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 106.35,
    y1: 387.17,
    x2: 137.34,
    y2: 387.17,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 106.26,
    y1: 420.99,
    x2: 137.25,
    y2: 420.99,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 106.16,
    y1: 454.82,
    x2: 137.15,
    y2: 454.82,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 106.07,
    y1: 488.65,
    x2: 137.05,
    y2: 488.65,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 251.9,
    y1: 385.31,
    x2: 282.89,
    y2: 385.31,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 252,
    y1: 419.14,
    x2: 282.99,
    y2: 419.14,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 252.1,
    y1: 452.97,
    x2: 283.09,
    y2: 452.97,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 252.19,
    y1: 486.79,
    x2: 283.18,
    y2: 486.79,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 125.68,
    y1: 376.37,
    x2: 193.6,
    y2: 376.37,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 57.32,
    y1: 376.37,
    x2: 125.7,
    y2: 376.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 57.34,
    y1: 353.03,
    x2: 193.6,
    y2: 353.03,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 125.53,
    y1: 91.11,
    x2: 125.53,
    y2: 374.93,
    xlinkHref: "#linear-gradient-200"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 1237.95,
    y1: 635.12,
    x2: 1314.57,
    y2: 635.12,
    gradientTransform: "matrix(-1, 0, 0, 1, 1717.02, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-9",
    x1: 1347.11,
    y1: 561.12,
    x2: 1374.81,
    y2: 609.09,
    gradientTransform: "matrix(-1, 0, 0, 1, 1717.02, 0)",
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-10",
    x1: 429.83,
    y1: 621.92,
    x2: 433.58,
    y2: 628.42,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-11",
    x1: 281.91,
    y1: 536.92,
    x2: 282.92,
    y2: 538.68,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 1314.57,
    y1: 609.16,
    x2: 1480.71,
    y2: 609.16,
    gradientTransform: "matrix(-1, 0, 0, 1, 1717.02, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-12",
    x1: 442.99,
    y1: 635.73,
    x2: 443.89,
    y2: 637.28,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-13",
    x1: 457.87,
    y1: 626.94,
    x2: 458.96,
    y2: 628.81,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-14",
    x1: 462.53,
    y1: 624.25,
    x2: 463.61,
    y2: 626.12,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-15",
    x1: 467.18,
    y1: 621.56,
    x2: 468.26,
    y2: 623.44,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-16",
    x1: 471.84,
    y1: 618.87,
    x2: 472.92,
    y2: 620.75,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-17",
    x1: 412.97,
    y1: 653.29,
    x2: 414.06,
    y2: 655.16,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-18",
    x1: 417.63,
    y1: 650.6,
    x2: 418.72,
    y2: 652.47,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-19",
    x1: 422.28,
    y1: 647.92,
    x2: 423.36,
    y2: 649.79,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_16-20",
    x1: 426.94,
    y1: 645.23,
    x2: 428.02,
    y2: 647.1,
    xlinkHref: "#New_Gradient_Swatch_16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 1450.55,
    y1: 578.58,
    x2: 1463.19,
    y2: 578.58,
    gradientTransform: "matrix(-1, 0, 0, 1, 1717.02, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 1434.83,
    y1: 587.74,
    x2: 1447.47,
    y2: 587.74,
    gradientTransform: "matrix(-1, 0, 0, 1, 1717.02, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 1258.25,
    y1: 580.76,
    x2: 1466.01,
    y2: 580.76,
    gradientTransform: "matrix(-1, 0, 0, 1, 1717.02, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 234.94,
    y1: 520.97,
    x2: 236.54,
    y2: 605.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0571ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#029de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 269.19,
    y1: 520.33,
    x2: 270.79,
    y2: 605.3,
    xlinkHref: "#linear-gradient-231"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 85.73,
    y1: 233.16,
    x2: 108.47,
    y2: 272.54,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 147.82,
    y1: 197.31,
    x2: 170.56,
    y2: 236.7,
    xlinkHref: "#linear-gradient-164"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15-10",
    x1: 332.27,
    y1: 237.84,
    x2: 470.78,
    y2: 237.84,
    xlinkHref: "#New_Gradient_Swatch_15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 391.68,
    y1: 256.3,
    x2: 470.78,
    y2: 256.3,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 332.27,
    y1: 261.98,
    x2: 391.68,
    y2: 261.98,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_15-11",
    x1: 580.96,
    y1: 39.34,
    x2: 703.58,
    y2: 251.73,
    xlinkHref: "#New_Gradient_Swatch_15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M571.46,577.27a1.23,1.23,0,0,1-.64-.17l-180.18-104a1.28,1.28,0,0,1,0-2.22L570.77,367a1.29,1.29,0,0,1,1.29,0L752.17,470.92a1.28,1.28,0,0,1,0,2.22L572.1,577.1A1.23,1.23,0,0,1,571.46,577.27ZM393.85,472,571.46,574.51,749,472,571.41,369.57Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M571.47,596.1a1.24,1.24,0,0,1-.64-.18L358,473.14a1.28,1.28,0,0,1,0-2.22L570.77,348.16a1.29,1.29,0,0,1,1.29,0L784.79,470.92a1.28,1.28,0,0,1,0,2.22L572.11,595.92A1.24,1.24,0,0,1,571.47,596.1ZM361.23,472l210.24,121.3L781.58,472,571.42,350.75Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M571.48,614.7a1.33,1.33,0,0,1-.64-.17L325.78,473.13a1.27,1.27,0,0,1,0-2.21l245-141.37a1.27,1.27,0,0,1,1.28,0L817,470.92a1.27,1.27,0,0,1,0,2.21l-244.9,141.4A1.33,1.33,0,0,1,571.48,614.7ZM329,472,571.48,611.94,813.81,472,571.42,332.14Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M790.58,667a1.24,1.24,0,0,1-.64-.18l-78.29-45.17a1.28,1.28,0,0,1,0-2.22l78.27-45.16a1.27,1.27,0,0,1,1.28,0l78.26,45.16a1.27,1.27,0,0,1,0,2.22L791.22,666.8A1.24,1.24,0,0,1,790.58,667Zm-75.72-46.46,75.72,43.69,75.68-43.69-75.7-43.68Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M790.58,656.28a1.28,1.28,0,0,1-.65-.18l-59.74-34.47a1.27,1.27,0,0,1,0-2.22L789.92,585a1.27,1.27,0,0,1,1.28,0l59.73,34.46a1.28,1.28,0,0,1,0,2.22L791.22,656.1A1.24,1.24,0,0,1,790.58,656.28Zm-57.19-35.76,57.19,33,57.14-33-57.16-33Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.75,541.14a1.3,1.3,0,0,1-.64-.17l-78.3-45.18a1.28,1.28,0,0,1,0-2.22l78.28-45.16a1.27,1.27,0,0,1,1.28,0l78.26,45.16a1.28,1.28,0,0,1,0,2.22L242.39,541A1.33,1.33,0,0,1,241.75,541.14ZM166,494.68l75.73,43.7,75.67-43.7L241.73,451Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.74,530.44a1.33,1.33,0,0,1-.64-.17l-59.75-34.48a1.28,1.28,0,0,1-.64-1.11,1.31,1.31,0,0,1,.64-1.11l59.73-34.46a1.29,1.29,0,0,1,1.29,0l59.72,34.46a1.28,1.28,0,0,1,.64,1.11,1.26,1.26,0,0,1-.64,1.11l-59.71,34.48A1.33,1.33,0,0,1,241.74,530.44Zm-57.18-35.76,57.18,33,57.15-33-57.17-33Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M498.23,701.45a1.28,1.28,0,0,1-.64-.17l-70.93-41a1.31,1.31,0,0,1-.64-1.11,1.28,1.28,0,0,1,.64-1.11l112-64.65a1.28,1.28,0,0,1,1.28,2.22L429.87,659.2l69,39.86a1.28,1.28,0,0,1-.65,2.39Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M432.87,656.8c3.07,1.77,3.08,4.64,0,6.42a12.22,12.22,0,0,1-11.08,0c-3.07-1.78-3.08-4.65,0-6.42A12.22,12.22,0,0,1,432.87,656.8Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M427.37,665.83a12.66,12.66,0,0,1-6.19-1.5c-1.9-1.1-2.95-2.64-2.95-4.33a5.09,5.09,0,0,1,2.91-4.31,13.41,13.41,0,0,1,12.37,0h0c1.9,1.1,2.95,2.63,2.95,4.33a5.11,5.11,0,0,1-2.91,4.31A12.56,12.56,0,0,1,427.37,665.83Zm-.05-9.07a10,10,0,0,0-4.89,1.15,2.75,2.75,0,0,0-1.64,2.08,2.79,2.79,0,0,0,1.67,2.12,11,11,0,0,0,9.8,0c1-.61,1.64-1.37,1.64-2.09s-.61-1.5-1.67-2.11A10.09,10.09,0,0,0,427.32,656.76Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.22,469.63c3.07,1.77,3.09,4.65,0,6.42a12.22,12.22,0,0,1-11.08,0c-3.07-1.78-3.09-4.65,0-6.42A12.2,12.2,0,0,1,364.22,469.63Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.73,478.66a12.63,12.63,0,0,1-6.19-1.5,4.64,4.64,0,0,1,0-8.64,13.44,13.44,0,0,1,12.37,0c1.9,1.1,2.95,2.64,2.95,4.33a5.11,5.11,0,0,1-2.91,4.31A12.59,12.59,0,0,1,358.73,478.66Zm-.05-9.07a10,10,0,0,0-4.89,1.15c-1,.61-1.64,1.37-1.64,2.09s.61,1.49,1.67,2.11a11,11,0,0,0,9.8,0c1-.61,1.64-1.37,1.63-2.09s-.61-1.5-1.67-2.11h0A10.05,10.05,0,0,0,358.68,469.59Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M719.7,472.31c3.07,1.77,3.08,4.65,0,6.42a12.24,12.24,0,0,1-11.09,0c-3.06-1.77-3.08-4.64,0-6.42A12.22,12.22,0,0,1,719.7,472.31Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M714.2,481.34a12.66,12.66,0,0,1-6.19-1.5c-1.9-1.1-3-2.64-3-4.33s1-3.21,2.92-4.31a13.45,13.45,0,0,1,12.36,0h0c1.9,1.1,2.95,2.64,2.95,4.33s-1,3.21-2.91,4.31A12.56,12.56,0,0,1,714.2,481.34Zm-.05-9.07a10,10,0,0,0-4.89,1.15c-1,.61-1.64,1.37-1.64,2.09a2.8,2.8,0,0,0,1.67,2.11,11,11,0,0,0,9.8,0,2.75,2.75,0,0,0,1.64-2.09c0-.72-.61-1.49-1.67-2.11h0A10.09,10.09,0,0,0,714.15,472.27Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M468.85,572.7c3.07,1.77,3.09,4.64,0,6.42a12.22,12.22,0,0,1-11.08,0c-3.07-1.78-3.09-4.65,0-6.42A12.19,12.19,0,0,1,468.85,572.7Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M463.35,581.73a12.62,12.62,0,0,1-6.18-1.5c-1.91-1.11-3-2.64-3-4.33a5.1,5.1,0,0,1,2.92-4.31,13.42,13.42,0,0,1,12.36,0c1.91,1.1,3,2.63,3,4.33a5.1,5.1,0,0,1-2.92,4.3A12.44,12.44,0,0,1,463.35,581.73Zm-.05-9.08a10,10,0,0,0-4.88,1.16c-1.05.6-1.64,1.36-1.64,2.08s.61,1.5,1.67,2.12a11,11,0,0,0,9.79,0c1.05-.6,1.64-1.36,1.64-2.08s-.61-1.5-1.67-2.11h0A10.07,10.07,0,0,0,463.3,572.65Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M435.18,616c3.07,1.77,3.09,4.65,0,6.42a12.22,12.22,0,0,1-11.08,0c-3.07-1.78-3.09-4.65,0-6.42A12.22,12.22,0,0,1,435.18,616Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.68,625a12.66,12.66,0,0,1-6.19-1.5c-1.9-1.1-2.95-2.64-2.95-4.33a5.1,5.1,0,0,1,2.92-4.31,13.42,13.42,0,0,1,12.36,0h0c1.9,1.1,2.95,2.63,3,4.33s-1,3.21-2.92,4.31A12.56,12.56,0,0,1,429.68,625Zm-.05-9.07a9.94,9.94,0,0,0-4.88,1.15,2.73,2.73,0,0,0-1.64,2.09c0,.72.61,1.5,1.67,2.11a11,11,0,0,0,9.79,0c1-.61,1.64-1.37,1.64-2.09s-.61-1.5-1.67-2.11h0A10.06,10.06,0,0,0,429.63,615.91Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.66,620.44a1.29,1.29,0,0,1-1.11-.64,1.27,1.27,0,0,1,.47-1.75l91.92-53a1.28,1.28,0,1,1,1.28,2.21L430.3,620.27A1.23,1.23,0,0,1,429.66,620.44Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M463.33,576.52a1.29,1.29,0,0,1-1.11-.64,1.27,1.27,0,0,1,.47-1.75l37.22-21.48a1.28,1.28,0,0,1,1.28,2.22L464,576.35A1.23,1.23,0,0,1,463.33,576.52Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M714.18,476.14a1.28,1.28,0,0,1-.64-2.39l37.21-21.48a1.28,1.28,0,0,1,1.29,2.22L714.82,476A1.23,1.23,0,0,1,714.18,476.14Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M705.93,517.33c2.12,1.22,2.13,3.2,0,4.42a8.43,8.43,0,0,1-7.64,0c-2.11-1.22-2.12-3.2,0-4.42A8.41,8.41,0,0,1,705.93,517.33Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M702.14,524a9.14,9.14,0,0,1-4.46-1.08,4,4,0,0,1-2.23-3.34,3.93,3.93,0,0,1,2.21-3.31,9.67,9.67,0,0,1,8.91,0,3.59,3.59,0,0,1,0,6.64A9.09,9.09,0,0,1,702.14,524Zm0-6.26a6.46,6.46,0,0,0-3.17.75c-.58.34-.93.75-.93,1.09s.36.77,1,1.11a7.07,7.07,0,0,0,6.34,0c.59-.34.93-.75.93-1.09s-.35-.77-1-1.11h0A6.5,6.5,0,0,0,702.11,517.69Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M465.09,510.81c2.11,1.22,2.12,3.2,0,4.42a8.43,8.43,0,0,1-7.64,0c-2.11-1.22-2.12-3.2,0-4.42A8.43,8.43,0,0,1,465.09,510.81Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M461.3,517.43a9.08,9.08,0,0,1-4.47-1.09,3.59,3.59,0,0,1,0-6.64,9.72,9.72,0,0,1,8.92,0,3.59,3.59,0,0,1,0,6.64A8.92,8.92,0,0,1,461.3,517.43Zm0-6.26a6.42,6.42,0,0,0-3.16.75c-.59.34-.94.75-.94,1.09s.36.77,1,1.11a7.1,7.1,0,0,0,6.35,0c.58-.34.93-.74.93-1.09s-.36-.76-1-1.11h0A6.5,6.5,0,0,0,461.26,511.17Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M505.87,700.17c2.11,1.22,2.13,3.2,0,4.42a8.41,8.41,0,0,1-7.63,0c-2.12-1.22-2.13-3.2,0-4.42A8.41,8.41,0,0,1,505.87,700.17Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M502.08,706.79a9,9,0,0,1-4.46-1.09,3.59,3.59,0,0,1,0-6.64,9.69,9.69,0,0,1,8.92,0h0a3.59,3.59,0,0,1,0,6.64A9,9,0,0,1,502.08,706.79Zm0-6.26a6.46,6.46,0,0,0-3.17.75c-.59.34-.93.75-.93,1.09s.35.77.95,1.11a7.13,7.13,0,0,0,6.35,0c.58-.34.93-.74.93-1.09s-.36-.77-.95-1.11A6.55,6.55,0,0,0,502.05,700.53Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M631.07,670.58c2.11,1.22,2.12,3.2,0,4.42a8.41,8.41,0,0,1-7.63,0c-2.12-1.22-2.13-3.2,0-4.42A8.43,8.43,0,0,1,631.07,670.58Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M627.28,677.2a9.12,9.12,0,0,1-4.46-1.09,3.59,3.59,0,0,1,0-6.64,9.69,9.69,0,0,1,8.92,0,3.6,3.6,0,0,1,0,6.64A9.09,9.09,0,0,1,627.28,677.2Zm0-6.26a6.42,6.42,0,0,0-3.16.75c-.59.34-.93.75-.93,1.09s.35.77,1,1.11a7.1,7.1,0,0,0,6.35,0c.58-.34.93-.75.93-1.09s-.36-.77-1-1.11h0A6.57,6.57,0,0,0,627.24,670.94Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M568.18,662.62c2.12,1.22,2.13,3.2,0,4.42a8.43,8.43,0,0,1-7.64,0c-2.11-1.22-2.13-3.2,0-4.42A8.38,8.38,0,0,1,568.18,662.62Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M564.39,669.23a9.11,9.11,0,0,1-4.46-1.08,4,4,0,0,1-2.24-3.33,3.94,3.94,0,0,1,2.21-3.31,9.69,9.69,0,0,1,8.92,0h0a3.59,3.59,0,0,1,0,6.64A9.09,9.09,0,0,1,564.39,669.23Zm0-6.25a6.46,6.46,0,0,0-3.17.75c-.58.33-.93.74-.93,1.09s.36.76,1,1.11a7.16,7.16,0,0,0,6.35,0c.58-.34.93-.75.93-1.09s-.35-.77-1-1.11A6.5,6.5,0,0,0,564.36,663Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M681,576.88c-3.07,1.77-3.09,4.65,0,6.42a12.22,12.22,0,0,0,11.08,0c3.07-1.78,3.09-4.65,0-6.42A12.22,12.22,0,0,0,681,576.88Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M686.44,585.91a12.55,12.55,0,0,1-6.17-1.5c-1.88-1.1-2.92-2.63-2.92-4.31s1-3.23,2.95-4.33h0a13.44,13.44,0,0,1,12.37,0,5.11,5.11,0,0,1,2.92,4.31c0,1.69-1.05,3.23-3,4.33A12.67,12.67,0,0,1,686.44,585.91ZM681.59,578c-1.06.61-1.67,1.38-1.67,2.11s.59,1.48,1.63,2.09a11.06,11.06,0,0,0,9.81,0c1-.62,1.66-1.39,1.66-2.11s-.6-1.48-1.64-2.09a11,11,0,0,0-9.79,0Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M541.46,623.19c-3.07,1.77-3.09,4.64,0,6.41a12.22,12.22,0,0,0,11.08,0c3.07-1.78,3.09-4.65,0-6.42A12.16,12.16,0,0,0,541.46,623.19Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M547,632.22a12.46,12.46,0,0,1-6.18-1.51,4.64,4.64,0,0,1,0-8.63,13.42,13.42,0,0,1,12.36,0,5.1,5.1,0,0,1,2.92,4.31c0,1.69-1.05,3.23-3,4.32A12.56,12.56,0,0,1,547,632.22Zm0-9.08a10.07,10.07,0,0,0-4.91,1.16h0c-1.06.61-1.67,1.38-1.67,2.11s.59,1.48,1.64,2.08a11,11,0,0,0,9.79,0c1.06-.61,1.67-1.38,1.67-2.11s-.59-1.48-1.64-2.08A10,10,0,0,0,547,623.14Zm-5.55.05h0Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M645.42,639.18c-3.07,1.78-3.09,4.65,0,6.42a12.19,12.19,0,0,0,11.08,0c3.07-1.77,3.09-4.64,0-6.42A12.22,12.22,0,0,0,645.42,639.18Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M650.91,648.22a12.42,12.42,0,0,1-6.17-1.51,5.08,5.08,0,0,1-2.92-4.31c0-1.69,1-3.23,3-4.33a13.48,13.48,0,0,1,12.36,0c1.88,1.1,2.92,2.63,2.92,4.31s-1,3.24-3,4.33A12.5,12.5,0,0,1,650.91,648.22Zm.05-9.08a10.05,10.05,0,0,0-4.9,1.15h0c-1.06.62-1.67,1.39-1.67,2.12s.59,1.48,1.63,2.08a11,11,0,0,0,9.8,0c1.06-.61,1.67-1.38,1.67-2.11s-.6-1.48-1.64-2.09A10,10,0,0,0,651,639.14Zm-5.54,0h0Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M686.18,664.47a1.23,1.23,0,0,1-.64-.17L649.8,643.5a1.28,1.28,0,0,1,0-2.22l34.08-19.67-35-19.7a1.26,1.26,0,0,1-.66-1.11,1.27,1.27,0,0,1,.66-1.12L685.68,579a1.29,1.29,0,1,1,1.26,2.24L652.08,600.8l35,19.68a1.27,1.27,0,0,1,.65,1.11,1.3,1.3,0,0,1-.64,1.12L653,642.4l33.83,19.68a1.28,1.28,0,0,1-.65,2.39Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M686.18,664.47a1.28,1.28,0,0,1-.64-2.39l49.93-28.82a1.28,1.28,0,0,1,1.28,2.22L686.82,664.3A1.23,1.23,0,0,1,686.18,664.47Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M623.43,671.86a1.28,1.28,0,0,1-.64-.17l-70.93-41a1.28,1.28,0,0,1-.47-1.75,1.3,1.3,0,0,1,1.76-.47l70.93,41a1.28,1.28,0,0,1-.65,2.39Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M519.72,639c-3.07,1.77-3.08,4.65,0,6.42a12.24,12.24,0,0,0,11.09,0c3.06-1.77,3.08-4.64,0-6.42A12.22,12.22,0,0,0,519.72,639Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M525.22,648a12.57,12.57,0,0,1-6.18-1.51c-1.88-1.09-2.92-2.62-2.91-4.31s1-3.23,3-4.33h0a13.42,13.42,0,0,1,12.36,0,5.11,5.11,0,0,1,2.92,4.32c0,1.69-1.05,3.22-3,4.32A12.56,12.56,0,0,1,525.22,648Zm-4.86-7.93c-1.06.62-1.67,1.39-1.67,2.12s.6,1.48,1.64,2.08a11,11,0,0,0,9.8,0,2.8,2.8,0,0,0,1.67-2.11c0-.72-.6-1.48-1.64-2.09a11,11,0,0,0-9.8,0Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M560.55,663.9a1.4,1.4,0,0,1-.65-.17l-29.77-17.21a1.27,1.27,0,0,1-.47-1.75,1.29,1.29,0,0,1,1.75-.47l29.78,17.21a1.28,1.28,0,0,1-.64,2.39Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M318.19,267.27c-13.28,7.67-13.35,20.09-.16,27.76s34.64,7.66,47.91,0,13.35-20.09.16-27.75S331.46,259.61,318.19,267.27Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 84,
    height: 56,
    transform: "translate(231.46 252.94)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264,296.45c-13.28,7.67-13.35,20.1-.16,27.76s34.64,7.66,47.91,0,13.35-20.09.16-27.75S277.24,288.79,264,296.45Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 84,
    height: 55,
    transform: "translate(177.46 282.94)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M371.56,300.79c-13.28,7.66-13.35,20.09-.16,27.75s34.64,7.67,47.92,0,13.34-20.08.15-27.75S384.83,293.13,371.56,300.79Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 84,
    height: 56,
    transform: "translate(284.46 286.94)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M317.34,330c-13.28,7.67-13.35,20.09-.16,27.76s34.64,7.66,47.92,0,13.34-20.08.15-27.75S330.61,322.31,317.34,330Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 84,
    height: 56,
    transform: "translate(230.46 315.94)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M308.18,247.9l.08,25.89v.3l-.07-25.89c0-.1,0-.2,0-.3",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M308.19,248.2l.07,25.89a11.53,11.53,0,0,0,.22,1.94l-.07-25.89a11.77,11.77,0,0,1-.22-1.94",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M308.41,250.14l.07,25.89a12.16,12.16,0,0,0,.55,1.91L309,252.05a12.16,12.16,0,0,1-.55-1.91",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M308.18,247.9a12.08,12.08,0,0,0,.87,4.38c.07.17.14.34.22.51s.13.29.2.43.17.34.26.51.15.27.23.41.24.4.37.6l.24.36q.23.33.48.66l.21.28c.27.35.57.69.88,1l.25.26c.24.25.5.51.77.76l.37.34.49.43.46.39.53.41c.17.13.33.26.51.38s.38.27.57.4l.54.37.62.39.78.48c.73.43,1.5.82,2.29,1.2l.62.29c.71.33,1.43.64,2.17.93l.29.12c.79.3,1.6.57,2.43.83.57.18,1.16.34,1.74.5s.88.25,1.33.36c.62.15,1.25.27,1.87.4l1.37.28.58.09c.77.12,1.56.23,2.34.33l.69.08c.91.1,1.83.18,2.75.23l.51,0c.62,0,1.24,0,1.86,0h1.85l1.56-.05,1.71-.09,1.57-.13,1.69-.19c.51-.06,1-.14,1.51-.21s1.2-.2,1.8-.32,1.25-.23,1.87-.37l.44-.1q1.29-.31,2.55-.69l.71-.22c.7-.22,1.39-.46,2.07-.71l.58-.21c.62-.24,1.21-.5,1.81-.77.28-.12.58-.24.87-.38.85-.4,1.68-.83,2.48-1.29,6.68-3.86,10-8.92,10-14l.07,25.9c0,5-3.32,10.11-10,14-.8.46-1.63.89-2.49,1.3l-.87.38c-.51.22-1,.46-1.53.66l-.27.1-.59.22c-.68.25-1.36.48-2.06.7l-.72.22-.48.15c-.68.2-1.37.37-2.07.54l-.44.1-1,.23c-.27.06-.56.09-.84.15l-1.79.31c-.24,0-.48.09-.73.12s-.52.06-.79.09c-.56.07-1.12.14-1.69.19-.27,0-.54.07-.81.09l-.75,0-1.72.09-.87.05h-.68c-.62,0-1.24,0-1.86,0-.31,0-.62,0-.92,0l-.93,0-.52,0q-1.15-.06-2.31-.18l-.44,0-.68-.08c-.79-.09-1.57-.2-2.35-.33l-.57-.09-.28-.05c-.37-.06-.72-.16-1.09-.23-.63-.13-1.26-.25-1.87-.4-.45-.11-.89-.24-1.33-.36s-1.18-.32-1.75-.5l-.37-.1c-.7-.23-1.39-.47-2.06-.73l-.29-.12c-.74-.29-1.46-.6-2.17-.92l-.62-.3c-.78-.38-1.55-.77-2.29-1.2l-.41-.24-.37-.24-.61-.39-.55-.37-.57-.39-.5-.38-.53-.42-.47-.39-.49-.42-.2-.18-.17-.17c-.27-.25-.52-.51-.77-.76l-.25-.26c-.31-.34-.6-.68-.88-1l0,0c-.07-.08-.12-.16-.18-.24s-.33-.44-.48-.66-.16-.24-.23-.36-.26-.4-.38-.6-.07-.11-.1-.16l-.12-.25c-.1-.17-.18-.34-.27-.51s-.13-.28-.2-.43l-.21-.51c0-.08-.07-.15-.1-.23v0a11.65,11.65,0,0,1-.77-4.12Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M318.19,233.92c-13.28,7.67-13.35,20.09-.16,27.76s34.64,7.66,47.91,0,13.35-20.09.16-27.75S331.46,226.26,318.19,233.92Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254,277.08,254,303v.3L254,277.38c0-.1,0-.2,0-.3",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M254,277.38l.07,25.89a11.76,11.76,0,0,0,.22,2l-.07-25.9a11.53,11.53,0,0,1-.22-1.94",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M254.19,279.32l.07,25.9a12.36,12.36,0,0,0,.55,1.9l-.07-25.89a12.16,12.16,0,0,1-.55-1.91",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M254,277.08a12.08,12.08,0,0,0,.87,4.38c.07.17.14.34.22.51s.13.29.2.43.17.34.26.51l.23.41c.12.2.24.4.37.6l.24.36q.22.33.48.66l.21.28c.27.35.57.69.88,1l.25.26c.24.26.5.51.77.76l.37.35.48.42.47.39.53.42.51.38.57.4.54.36c.2.14.41.26.62.39s.51.33.78.48c.73.43,1.5.82,2.29,1.2l.62.3c.71.32,1.43.63,2.17.92l.29.12c.79.3,1.6.58,2.43.83.57.18,1.16.34,1.74.5s.88.25,1.33.36c.62.15,1.25.27,1.87.4.46.09.91.2,1.37.28l.58.09c.77.13,1.56.24,2.34.33l.69.08c.91.1,1.83.18,2.75.23l.51,0c.62,0,1.24,0,1.86.05s1.24,0,1.85,0l1.55,0,1.72-.1c.53,0,1.05-.08,1.57-.13s1.13-.11,1.69-.19,1-.13,1.51-.21,1.2-.2,1.8-.31,1.25-.24,1.87-.38l.44-.1q1.29-.31,2.55-.69l.71-.22c.7-.22,1.39-.45,2.07-.7l.58-.22c.62-.23,1.21-.5,1.81-.76l.87-.38c.85-.41,1.68-.84,2.48-1.3,6.68-3.86,10-8.92,10-14l.08,25.89c0,5.05-3.32,10.12-10,14-.8.46-1.63.89-2.49,1.3-.28.14-.58.25-.87.38-.51.23-1,.46-1.53.67a2.15,2.15,0,0,0-.27.1l-.59.21c-.68.25-1.36.49-2.06.7l-.72.23-.48.15c-.68.19-1.37.37-2.07.53l-.44.1-1,.23c-.27.06-.56.1-.84.15-.59.11-1.19.22-1.79.31l-.73.13c-.26,0-.52.05-.79.09l-1.69.19-.81.09-.75,0-1.72.09c-.29,0-.58,0-.87,0h-.68c-.62,0-1.24,0-1.86,0h-.92l-.93-.05-.52,0q-1.16-.07-2.31-.18l-.44-.05-.68-.09c-.79-.09-1.57-.2-2.35-.33l-.57-.09-.28,0c-.37-.07-.72-.16-1.09-.24-.63-.12-1.26-.25-1.87-.4-.45-.11-.89-.23-1.33-.36-.59-.15-1.18-.31-1.75-.49l-.37-.11c-.7-.23-1.39-.47-2.06-.73-.1,0-.19-.08-.29-.12-.74-.28-1.46-.59-2.17-.92l-.62-.29c-.78-.38-1.55-.78-2.29-1.2l-.41-.25-.37-.24c-.21-.12-.42-.25-.61-.38l-.55-.37-.57-.4-.51-.38-.52-.42a5.71,5.71,0,0,1-.47-.39l-.49-.42-.2-.18-.17-.17c-.27-.25-.52-.5-.77-.76l-.25-.26c-.31-.33-.6-.68-.88-1l0-.05c-.07-.08-.12-.16-.18-.24s-.33-.43-.48-.65l-.23-.37c-.13-.2-.26-.4-.38-.6l-.1-.16-.12-.25c-.1-.17-.18-.34-.27-.51l-.2-.42-.21-.52c0-.07-.07-.15-.1-.23v0A11.7,11.7,0,0,1,254,303Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M264,263.11c-13.28,7.66-13.35,20.09-.16,27.75s34.64,7.66,47.91,0,13.35-20.09.16-27.75S277.24,255.44,264,263.11Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M361.56,281.41l.07,25.9v.29l-.07-25.89v-.3",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M361.56,281.71l.07,25.89a11.78,11.78,0,0,0,.23,1.95l-.08-25.89a11.76,11.76,0,0,1-.22-2",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M361.78,283.66l.08,25.89a12.42,12.42,0,0,0,.54,1.91l-.07-25.9a12.36,12.36,0,0,1-.55-1.9",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M361.56,281.41a11.67,11.67,0,0,0,.87,4.38c.06.17.14.35.21.52l.2.42.26.51c.08.14.15.28.23.41s.25.4.38.6l.23.37c.15.22.31.44.48.65l.21.29c.28.34.57.69.88,1l.25.26c.25.26.5.51.77.76s.24.24.37.35l.49.43c.15.13.3.26.46.38l.53.42.51.38.57.4.54.37.62.39.78.48c.74.42,1.51.82,2.29,1.2l.62.29c.71.33,1.43.64,2.17.93l.29.11c.79.3,1.61.58,2.43.84.57.18,1.16.34,1.74.49s.89.25,1.34.36c.61.15,1.24.28,1.87.4.45.1.9.2,1.37.28l.57.09c.78.13,1.56.24,2.35.33l.68.09c.91.09,1.83.17,2.75.23l.51,0c.62,0,1.24,0,1.86.05s1.24,0,1.86,0l1.55,0,1.72-.09,1.56-.13,1.69-.19,1.52-.22c.6-.09,1.2-.2,1.79-.31s1.26-.24,1.87-.38l.44-.1c.86-.2,1.71-.43,2.55-.68l.72-.23c.69-.21,1.38-.45,2.06-.7l.58-.21c.62-.24,1.21-.51,1.81-.77l.87-.38c.85-.41,1.69-.84,2.49-1.3,6.67-3.85,10-8.92,10-14l.07,25.89c0,5.06-3.32,10.12-10,14-.8.47-1.63.9-2.49,1.3-.28.14-.58.25-.87.38-.51.23-1,.46-1.53.67l-.27.1-.59.21c-.67.25-1.36.49-2.06.71l-.72.22-.48.15c-.68.19-1.37.37-2.07.53l-.44.1-1,.24-.84.14c-.6.12-1.2.22-1.8.31-.24,0-.48.1-.72.13s-.53.06-.79.09l-1.7.19c-.27,0-.53.07-.81.09l-.75,0c-.57,0-1.14.07-1.72.09l-.86.05h-3.47l-.93-.05-.52,0c-.77-.05-1.54-.1-2.31-.18l-.44-.05-.68-.08q-1.18-.15-2.34-.33l-.58-.1-.28,0-1.09-.23-1.87-.4c-.45-.11-.89-.24-1.33-.36s-1.17-.32-1.75-.5l-.37-.11c-.7-.22-1.38-.47-2.06-.72l-.29-.12c-.74-.29-1.46-.6-2.17-.93l-.62-.29c-.78-.38-1.55-.78-2.28-1.2l-.42-.25c-.13-.07-.25-.15-.37-.23l-.61-.39-.55-.37-.57-.4-.5-.38-.53-.41-.47-.39-.49-.43-.2-.17-.17-.17c-.27-.25-.52-.51-.77-.77l-.24-.25c-.31-.34-.61-.68-.88-1l0,0-.18-.24-.48-.66-.23-.36c-.13-.2-.26-.4-.37-.6l-.1-.17c-.05-.08-.09-.16-.13-.24s-.18-.34-.26-.51-.14-.29-.2-.43-.15-.34-.22-.52l-.1-.22v0a11.92,11.92,0,0,1-.77-4.12Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M371.56,267.44c-13.28,7.66-13.35,20.09-.16,27.76s34.64,7.66,47.92,0,13.34-20.08.15-27.75S384.83,259.78,371.56,267.44Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.33,310.6l.08,25.89v.3l-.07-25.9c0-.09,0-.19,0-.29",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M307.34,310.89l.07,25.9a11.67,11.67,0,0,0,.23,1.94l-.08-25.89a11.76,11.76,0,0,1-.22-1.95",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M307.56,312.84l.08,25.89a12.12,12.12,0,0,0,.54,1.91l-.07-25.89a12.48,12.48,0,0,1-.55-1.91",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M307.33,310.6a11.88,11.88,0,0,0,.88,4.38c.06.17.14.34.21.51s.13.28.2.43l.26.51c.08.13.15.27.23.41s.25.4.38.6.15.24.23.36.31.44.48.66l.21.28c.28.35.57.69.88,1l.25.25c.25.26.5.52.77.77l.37.34.49.43.46.39.53.41.51.38.57.4.54.37.62.39.78.48c.74.43,1.51.82,2.29,1.2l.62.29c.71.33,1.43.64,2.17.93l.29.12c.79.3,1.61.57,2.43.83.57.18,1.16.34,1.74.5s.89.25,1.34.36c.61.15,1.24.27,1.86.4.46.09.91.19,1.38.27l.57.1c.78.12,1.56.23,2.35.33l.68.08c.91.1,1.83.17,2.75.23l.51,0c.62,0,1.24,0,1.86.06h1.86c.51,0,1,0,1.55,0l1.72-.09,1.56-.13,1.69-.19,1.52-.21c.6-.1,1.2-.2,1.79-.32s1.25-.23,1.87-.38l.44-.09q1.29-.31,2.55-.69l.72-.22c.69-.22,1.38-.46,2.06-.71l.58-.21c.62-.24,1.21-.5,1.81-.77.29-.13.59-.24.87-.38.85-.4,1.69-.83,2.49-1.3,6.67-3.85,10-8.91,10-14l.07,25.9c0,5.05-3.32,10.11-10,14-.8.46-1.63.89-2.49,1.3l-.87.38c-.51.22-1,.46-1.53.66l-.27.1-.59.22c-.67.25-1.36.48-2.06.7l-.72.22c-.16,0-.31.11-.48.15-.68.2-1.37.37-2.07.54l-.44.1-1,.23c-.28.06-.57.09-.84.15l-1.8.31c-.24,0-.48.09-.72.12s-.53.06-.79.09c-.57.07-1.13.14-1.7.19-.27,0-.53.07-.81.09l-.75,0c-.57,0-1.14.07-1.72.09l-.86.05H342c-.62,0-1.24,0-1.86,0h-.92l-.93,0-.52,0q-1.16-.06-2.31-.18l-.44-.05-.68-.08q-1.19-.14-2.34-.33l-.58-.09-.28-.05c-.37-.06-.72-.16-1.09-.23-.63-.13-1.25-.25-1.87-.4-.45-.11-.89-.24-1.33-.36-.59-.16-1.17-.32-1.75-.5l-.37-.1c-.7-.23-1.38-.47-2.06-.73l-.29-.12c-.74-.29-1.46-.6-2.17-.93l-.62-.29c-.78-.38-1.55-.77-2.28-1.2l-.42-.24-.37-.24-.61-.39-.55-.37-.57-.4-.5-.38-.53-.41-.47-.39-.49-.42-.2-.18-.17-.17c-.27-.25-.52-.51-.77-.76l-.24-.26c-.32-.34-.61-.68-.88-1l0,0-.18-.24-.48-.66-.23-.36c-.13-.2-.26-.4-.37-.6l-.1-.17c0-.08-.09-.16-.13-.24s-.18-.34-.26-.51-.14-.28-.2-.43-.15-.34-.22-.51-.07-.15-.1-.23v0a11.92,11.92,0,0,1-.77-4.12Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M317.34,296.62c-13.28,7.67-13.35,20.09-.16,27.76s34.64,7.66,47.92,0,13.34-20.08.15-27.74S330.61,289,317.34,296.62Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M747.45,461.48c5.1,2.94,5.13,7.77.06,10.71L589.93,563.77c-5.07,2.94-13.4,2.94-18.5,0L321.63,419.54c-5.14-3-5.13-7.77-.06-10.71l157.58-91.58c5.06-2.94,13.35-3,18.49,0Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 450,
    height: 267,
    transform: "translate(240.46 306.94)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M763.28,435l-9.23,5.37c1.66-1,2.7-3,2.71-5.95L766,429C766,431.93,764.94,434,763.28,435Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M491.61,91.26l9.23-5.36c1.68-1,4-.84,6.61.66l-9.23,5.36C495.63,90.42,493.3,90.28,491.61,91.26Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "688.74 252.16 697.96 246.8 697.45 429.01 688.22 434.37 688.74 252.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "429.52 91.92 438.75 86.56 688.55 230.78 679.33 236.14 429.52 91.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M748,236.14l9.22-5.36c5.1,2.94,9.27,10.11,9.25,16l-9.23,5.36C757.29,246.25,753.13,239.09,748,236.14Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M748,236.14c5.1,3,9.26,10.11,9.24,16l-.51,182.21c0,5.91-4.21,8.25-9.31,5.3L497.64,295.45c-5.14-3-9.26-10.11-9.24-16l.51-182.21c0-5.9,4.17-8.27,9.31-5.3Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "679.27 257.17 678.81 418.63 587.87 366.11 568.83 355.13 561.83 351.08 523.3 328.87 520.73 327.38 471.4 298.88 429 274.4 429.46 112.94 437.64 117.66 476.81 140.26 486.97 146.14 515.32 162.5 535.07 173.92 547.95 181.36 679.27 257.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "523.3 328.87 520.73 327.38 471.4 298.88 437.64 117.66 476.81 140.26 523.3 328.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "587.87 366.11 568.83 355.13 535.07 173.92 547.95 181.36 587.87 366.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M751.29,445.07l0,10.67c0,1.93-1.26,3.86-3.78,5.32l0-10.67C750,448.92,751.29,447,751.29,445.07Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "678.81 450.39 678.78 461.06 521.2 552.63 521.23 541.96 678.81 450.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M571.43,542,321.63,397.74c-2.58-1.49-3.86-3.45-3.86-5.39l0,10.67c0,2,1.28,3.9,3.86,5.39L571.4,552.63c5.1,3,13.43,3,18.5,0l0-10.67C584.86,544.91,576.53,544.91,571.43,542Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M747.45,439.67c5.1,2.95,5.13,7.77.06,10.72L589.93,542c-5.07,2.95-13.4,2.95-18.5,0L321.63,397.74c-5.14-3-5.13-7.77-.06-10.72l157.58-91.57c5.06-2.95,13.35-3,18.49,0Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M544.79,466.71l-92.07-53.16a10.19,10.19,0,0,0-9.25,0l-26.08,15.16c-2.53,1.47-2.52,3.88,0,5.35l92.08,53.16a10.14,10.14,0,0,0,9.24,0l26.08-15.15c2.57-1.5,2.56-3.86,0-5.36",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "431.69 311.75 431.68 314.42 414.87 324.19 414.87 321.52 431.69 311.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "414.87 321.52 414.87 324.19 398.31 314.63 398.32 311.97 414.87 321.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "431.69 311.75 414.87 321.52 398.32 311.97 415.14 302.19 431.69 311.75"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "452.92 324.01 452.91 326.68 436.1 336.45 436.1 333.78 452.92 324.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "436.1 333.78 436.1 336.45 419.5 326.87 419.51 324.2 436.1 333.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "452.92 324.01 436.1 333.78 419.51 324.2 436.33 314.43 452.92 324.01"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "474.11 336.24 474.1 338.91 457.29 348.68 457.29 346.01 474.11 336.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "457.29 346.01 457.29 348.68 440.74 339.13 440.74 336.46 457.29 346.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "474.11 336.24 457.29 346.01 440.74 336.46 457.56 326.69 474.11 336.24"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "495.3 348.48 495.29 351.14 478.48 360.92 478.48 358.25 495.3 348.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "478.48 358.25 478.48 360.92 461.93 351.36 461.93 348.69 478.48 358.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "495.3 348.48 478.48 358.25 461.93 348.69 478.75 338.92 495.3 348.48"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "516.49 360.71 516.48 363.38 499.67 373.15 499.67 370.48 516.49 360.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "499.67 370.48 499.67 373.15 483.12 363.59 483.12 360.93 499.67 370.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "516.49 360.71 499.67 370.48 483.12 360.93 499.94 351.15 516.49 360.71"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "537.72 372.97 537.71 375.63 520.9 385.41 520.9 382.74 537.72 372.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "520.9 382.74 520.9 385.41 504.35 375.85 504.36 373.18 520.9 382.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "537.72 372.97 520.9 382.74 504.36 373.18 521.17 363.41 537.72 372.97"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "558.91 385.2 558.9 387.87 542.09 397.64 542.1 394.97 558.91 385.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "542.1 394.97 542.09 397.64 525.54 388.09 525.54 385.42 542.1 394.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "558.91 385.2 542.1 394.97 525.54 385.42 542.36 375.65 558.91 385.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "580.1 397.44 580.09 400.1 563.28 409.88 563.28 407.21 580.1 397.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "563.28 407.21 563.28 409.88 546.73 400.32 546.73 397.65 563.28 407.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "580.1 397.44 563.28 407.21 546.73 397.65 563.55 387.88 580.1 397.44"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "601.33 409.69 601.33 412.36 584.51 422.13 584.52 419.47 601.33 409.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "584.52 419.47 584.51 422.13 567.92 412.55 567.92 409.89 584.52 419.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "601.33 409.69 584.52 419.47 567.92 409.89 584.74 400.11 601.33 409.69"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "622.52 421.93 622.52 424.6 605.7 434.37 605.71 431.7 622.52 421.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "605.71 431.7 605.7 434.37 589.15 424.81 589.16 422.14 605.71 431.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "622.52 421.93 605.71 431.7 589.16 422.14 605.97 412.37 622.52 421.93"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "664.94 446.42 664.94 449.09 648.12 458.86 648.13 456.19 664.94 446.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "648.13 456.19 648.12 458.86 610.34 437.05 610.35 434.38 648.13 456.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "664.94 446.42 648.13 456.19 610.35 434.38 627.16 424.61 664.94 446.42"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "431.5 336.46 431.49 339.13 414.71 348.88 414.72 346.21 431.5 336.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "414.72 346.21 414.71 348.88 376.93 327.06 376.94 324.39 414.72 346.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "431.5 336.46 414.72 346.21 376.94 324.39 393.71 314.64 431.5 336.46"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "452.69 348.69 452.68 351.36 435.9 361.11 435.91 358.44 452.69 348.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "435.91 358.44 435.9 361.11 419.35 351.55 419.36 348.89 435.91 358.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "452.69 348.69 435.91 358.44 419.36 348.89 436.13 339.14 452.69 348.69"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "473.88 360.93 473.87 363.59 457.09 373.34 457.1 370.68 473.88 360.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "457.1 370.68 457.09 373.34 440.54 363.79 440.55 361.12 457.1 370.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "473.88 360.93 457.1 370.68 440.55 361.12 457.32 351.37 473.88 360.93"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "495.06 373.16 495.06 375.83 478.28 385.58 478.29 382.91 495.06 373.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "478.29 382.91 478.28 385.58 461.73 376.02 461.74 373.35 478.29 382.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "495.06 373.16 478.29 382.91 461.74 373.35 478.51 363.61 495.06 373.16"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "516.3 385.42 516.29 388.09 499.51 397.83 499.52 395.17 516.3 385.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "499.52 395.17 499.51 397.83 482.96 388.28 482.97 385.61 499.52 395.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "516.3 385.42 499.52 395.17 482.97 385.61 499.75 375.86 516.3 385.42"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "537.49 397.65 537.48 400.32 520.7 410.07 520.71 407.4 537.49 397.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "520.71 407.4 520.7 410.07 504.15 400.51 504.16 397.85 520.71 407.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "537.49 397.65 520.71 407.4 504.16 397.85 520.93 388.1 537.49 397.65"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "558.68 409.89 558.67 412.55 541.89 422.3 541.9 419.63 558.68 409.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "541.9 419.63 541.89 422.3 525.34 412.75 525.35 410.08 541.9 419.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "558.68 409.89 541.9 419.63 525.35 410.08 542.13 400.33 558.68 409.89"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "579.91 422.14 579.9 424.81 563.13 434.56 563.13 431.89 579.91 422.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "563.13 431.89 563.13 434.56 546.53 424.98 546.54 422.31 563.13 431.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "579.91 422.14 563.13 431.89 546.54 422.31 563.32 412.56 579.91 422.14"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "601.1 434.38 601.09 437.05 584.32 446.8 584.32 444.13 601.1 434.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "584.32 444.13 584.32 446.8 567.76 437.24 567.77 434.57 584.32 444.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "601.1 434.38 584.32 444.13 567.77 434.57 584.55 424.82 601.1 434.38"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "622.29 446.61 622.28 449.28 605.5 459.03 605.51 456.36 622.29 446.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "605.51 456.36 605.5 459.03 588.95 449.47 588.96 446.81 605.51 456.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "622.29 446.61 605.51 456.36 588.96 446.81 605.74 437.06 622.29 446.61"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "643.52 458.87 643.51 461.54 626.74 471.29 626.74 468.62 643.52 458.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "626.74 468.62 626.74 471.29 610.14 461.71 610.15 459.04 626.74 468.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "643.52 458.87 626.74 468.62 610.15 459.04 626.93 449.29 643.52 458.87"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "410.11 348.89 410.1 351.55 393.33 361.3 393.34 358.63 410.11 348.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "393.34 358.63 393.33 361.3 355.55 339.49 355.55 336.82 393.34 358.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "410.11 348.89 393.34 358.63 355.55 336.82 372.33 327.07 410.11 348.89"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "431.3 361.12 431.29 363.79 414.52 373.54 414.52 370.87 431.3 361.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "414.52 370.87 414.52 373.54 397.97 363.98 397.98 361.31 414.52 370.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "431.3 361.12 414.52 370.87 397.98 361.31 414.75 351.56 431.3 361.12"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "452.49 373.35 452.48 376.02 435.71 385.77 435.71 383.1 452.49 373.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "435.71 383.1 435.71 385.77 419.16 376.21 419.17 373.55 435.71 383.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "452.49 373.35 435.71 383.1 419.17 373.55 435.94 363.8 452.49 373.35"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "473.68 385.59 473.67 388.26 456.9 398 456.9 395.34 473.68 385.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "456.9 395.34 456.9 398 440.35 388.45 440.35 385.78 456.9 395.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "473.68 385.59 456.9 395.34 440.35 385.78 457.13 376.03 473.68 385.59"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "494.91 397.85 494.9 400.51 478.13 410.26 478.14 407.59 494.91 397.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "478.14 407.59 478.13 410.26 461.58 400.71 461.59 398.04 478.14 407.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "494.91 397.85 478.14 407.59 461.59 398.04 478.36 388.29 494.91 397.85"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "516.1 410.08 516.09 412.75 499.32 422.5 499.33 419.83 516.1 410.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "499.33 419.83 499.32 422.5 482.77 412.94 482.78 410.27 499.33 419.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "516.1 410.08 499.33 419.83 482.78 410.27 499.55 400.52 516.1 410.08"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "537.29 422.31 537.28 424.98 520.51 434.73 520.52 432.06 537.29 422.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "520.52 432.06 520.51 434.73 503.96 425.18 503.97 422.51 520.52 432.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "537.29 422.31 520.52 432.06 503.97 422.51 520.74 412.76 537.29 422.31"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "558.52 434.57 558.52 437.24 541.74 446.99 541.75 444.32 558.52 434.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "541.75 444.32 541.74 446.99 525.15 437.41 525.16 434.74 541.75 444.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "558.52 434.57 541.75 444.32 525.16 434.74 541.93 424.99 558.52 434.57"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "579.71 446.81 579.71 449.47 562.93 459.22 562.94 456.55 579.71 446.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "562.94 456.55 562.93 459.22 546.38 449.67 546.39 447 562.94 456.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "579.71 446.81 562.94 456.55 546.39 447 563.16 437.25 579.71 446.81"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "622.13 471.3 622.13 473.97 605.35 483.71 605.36 481.05 622.13 471.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "605.36 481.05 605.35 483.71 567.57 461.9 567.58 459.23 605.36 481.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "622.13 471.3 605.36 481.05 567.58 459.23 584.35 449.48 622.13 471.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "409.92 373.55 409.91 376.21 393.13 385.96 393.14 383.3 409.92 373.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "393.14 383.3 393.13 385.96 334.16 351.92 334.17 349.25 393.14 383.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "409.92 373.55 393.14 383.3 334.17 349.25 350.94 339.5 409.92 373.55"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "431.11 385.78 431.1 388.45 414.32 398.2 414.33 395.53 431.11 385.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "414.33 395.53 414.32 398.2 397.77 388.64 397.78 385.97 414.33 395.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "431.11 385.78 414.33 395.53 397.78 385.97 414.56 376.23 431.11 385.78"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "452.3 398.01 452.29 400.68 435.51 410.43 435.52 407.76 452.3 398.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "435.52 407.76 435.51 410.43 418.96 400.88 418.97 398.21 435.52 407.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "452.3 398.01 435.52 407.76 418.97 398.21 435.75 388.46 452.3 398.01"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "473.53 410.27 473.52 412.94 456.75 422.69 456.75 420.02 473.53 410.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "456.75 420.02 456.75 422.69 440.19 413.13 440.2 410.47 456.75 420.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "473.53 410.27 456.75 420.02 440.2 410.47 456.98 400.72 473.53 410.27"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "494.72 422.51 494.71 425.18 477.94 434.92 477.94 432.25 494.72 422.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "477.94 432.25 477.94 434.92 461.38 425.37 461.39 422.7 477.94 432.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "494.72 422.51 477.94 432.25 461.39 422.7 478.17 412.95 494.72 422.51"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "515.91 434.74 515.9 437.41 499.13 447.16 499.13 444.49 515.91 434.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "499.13 444.49 499.13 447.16 482.57 437.6 482.58 434.93 499.13 444.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "515.91 434.74 499.13 444.49 482.58 434.93 499.36 425.19 515.91 434.74"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "537.14 447 537.13 449.67 520.36 459.42 520.36 456.75 537.14 447"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "520.36 456.75 520.36 459.42 503.76 449.84 503.77 447.17 520.36 456.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "537.14 447 520.36 456.75 503.77 447.17 520.55 437.42 537.14 447"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "558.33 459.23 558.32 461.9 541.55 471.65 541.55 468.98 558.33 459.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "541.55 468.98 541.55 471.65 525 462.09 525 459.43 541.55 468.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "558.33 459.23 541.55 468.98 525 459.43 541.78 449.68 558.33 459.23"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "600.75 483.73 600.74 486.39 583.97 496.14 583.98 493.47 600.75 483.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "583.98 493.47 583.97 496.14 546.18 474.33 546.19 471.66 583.98 493.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "600.75 483.73 583.98 493.47 546.19 471.66 562.97 461.91 600.75 483.73"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "346.11 361.48 346.1 364.15 329.29 373.92 329.29 371.25 346.11 361.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "329.29 371.25 329.29 373.92 312.74 364.37 312.74 361.7 329.29 371.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "346.11 361.48 329.29 371.25 312.74 361.7 329.56 351.93 346.11 361.48"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "367.34 373.74 367.33 376.41 350.52 386.18 350.53 383.51 367.34 373.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "350.53 383.51 350.52 386.18 333.93 376.6 333.93 373.93 350.53 383.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "367.34 373.74 350.53 383.51 333.93 373.93 350.75 364.16 367.34 373.74"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "388.53 385.97 388.52 388.64 371.71 398.42 371.72 395.75 388.53 385.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "371.72 395.75 371.71 398.42 355.16 388.86 355.17 386.19 371.72 395.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "388.53 385.97 371.72 395.75 355.17 386.19 371.98 376.42 388.53 385.97"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "494.52 447.17 494.51 449.84 477.7 459.61 477.71 456.94 494.52 447.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "477.71 456.94 477.7 459.61 376.35 401.09 376.35 398.43 477.71 456.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "494.52 447.17 477.71 456.94 376.35 398.43 393.17 388.65 494.52 447.17"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "515.75 459.43 515.75 462.09 498.93 471.87 498.94 469.2 515.75 459.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "498.94 469.2 498.93 471.87 482.34 462.29 482.35 459.62 498.94 469.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "515.75 459.43 498.94 469.2 482.35 459.62 499.16 449.85 515.75 459.43"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "536.95 471.66 536.94 474.33 520.12 484.1 520.13 481.43 536.95 471.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "520.13 481.43 520.12 484.1 503.57 474.55 503.58 471.88 520.13 481.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "536.95 471.66 520.13 481.43 503.58 471.88 520.39 462.1 536.95 471.66"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "579.37 496.15 579.36 498.82 562.54 508.59 562.55 505.93 579.37 496.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "562.55 505.93 562.54 508.59 524.76 486.78 524.77 484.11 562.55 505.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "579.37 496.15 562.55 505.93 524.77 484.11 541.58 474.34 579.37 496.15"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "590.59 253.54 590.42 313.01 538.67 283.13 538.84 223.67 590.59 253.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "586.46 255.9 586.31 305.89 542.81 280.77 542.95 230.78 586.46 255.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "586.46 255.9 588.49 255.91 588.33 309.4 540.77 281.94 540.93 227.27 588.49 254.73 588.49 255.91 586.46 255.9 585.44 257.66 544.97 234.29 544.84 279.61 584.29 302.39 584.43 255.89 586.46 255.9 585.44 257.66 586.46 255.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "577.95 284.22 569.08 273.42 556.97 269.87 548.4 258.41 549.12 257.87 557.51 269.1 569.6 272.64 578.64 283.65 577.95 284.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "640.01 304.44 640 306.8 602.47 285.13 602.48 282.77 640.01 304.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "640.03 297 640.02 299.36 602.49 277.69 602.5 275.33 640.03 297"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "640.05 289.55 640.04 291.92 602.51 270.25 602.52 267.88 640.05 289.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "640.07 282.11 640.06 284.47 602.53 262.8 602.54 260.44 640.07 282.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "639.96 319.33 639.96 321.69 602.43 300.02 602.43 297.66 639.96 319.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "639.99 311.88 639.98 314.25 602.45 292.58 602.46 290.21 639.99 311.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "630.43 321.28 630.42 323.64 602.41 307.46 602.41 305.1 630.43 321.28"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M614.84,203.76a3.94,3.94,0,0,1,1.78,3.09c0,1.13-.81,1.59-1.79,1a3.93,3.93,0,0,1-1.8-3.09C613,203.63,613.84,203.18,614.84,203.76Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M717.1,259.52a7.59,7.59,0,0,1,3.41,5.93l0,16.18a6.87,6.87,0,0,0-3.12-5.42l-119.16-68.8c-1.73-1-3.14-.19-3.15,1.81l.05-16.19c0-2.18,1.55-3.06,3.45-2ZM607.6,203.7c1,.57,1.79.11,1.79-1a3.92,3.92,0,0,0-1.78-3.09c-1-.58-1.81-.13-1.81,1a4,4,0,0,0,1.8,3.1m7.23,4.17c1,.57,1.79.11,1.79-1a3.94,3.94,0,0,0-1.78-3.09c-1-.58-1.81-.13-1.81,1a3.93,3.93,0,0,0,1.8,3.09m-14.46-8.35c1,.57,1.79.11,1.79-1a3.92,3.92,0,0,0-1.78-3.09c-1-.57-1.79-.12-1.8,1a3.91,3.91,0,0,0,1.79,3.08",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M717.34,276.21a6.87,6.87,0,0,1,3.12,5.42l-.22,77.85c0,2-1.41,2.8-3.14,1.8L597.94,292.49a6.94,6.94,0,0,1-3.13-5.43l.22-77.84c0-2,1.42-2.81,3.15-1.81ZM659.12,313l.17-59.47-51.75-29.87-.17,59.46L659.12,313m49.56,1.24v-2.37l-37.53-21.67v2.37l37.53,21.67m.06-22.33v-2.37l-37.53-21.67v2.38l37.53,21.66m0,7.44V297L671.2,275.33v2.36l37.53,21.67m0-14.89v-2.36l-37.53-21.67v2.36l37.53,21.67m-.1,37.22v-2.36l-37.53-21.67V300l37.53,21.67m0-14.89v-2.36l-37.52-21.67v2.36L708.7,306.8m-9.58,16.84v-2.36l-28-16.18v2.36l28,16.18",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M600.38,195.41a3.92,3.92,0,0,1,1.78,3.09c0,1.13-.81,1.59-1.79,1a3.91,3.91,0,0,1-1.79-3.08C598.59,195.29,599.38,194.84,600.38,195.41Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M607.61,199.59a3.92,3.92,0,0,1,1.78,3.09c0,1.13-.81,1.59-1.79,1a4,4,0,0,1-1.8-3.1C605.8,199.46,606.61,199,607.61,199.59Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M647,281.88a4,4,0,0,1,1.78,3.09c0,1.14-.81,1.6-1.8,1a4,4,0,0,1-1.79-3.1C645.2,281.76,646,281.31,647,281.88Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M638.05,271a3.92,3.92,0,0,1,1.79,3.09c0,1.13-.81,1.59-1.8,1a4,4,0,0,1-1.79-3.1C636.25,270.85,637.06,270.4,638.05,271Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M626,267.43a3.94,3.94,0,0,1,1.79,3.09c0,1.13-.81,1.59-1.8,1a4,4,0,0,1-1.79-3.1C624.15,267.3,625,266.86,626,267.43Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M617.47,256.09a3.94,3.94,0,0,1,1.78,3.09c0,1.13-.81,1.59-1.79,1a4,4,0,0,1-1.8-3.1C615.66,256,616.47,255.51,617.47,256.09Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "589.07 435.27 599.3 434.63 617.33 446.8 606.95 446.93 589.07 435.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M683.63,422.93c-3.81,5.59-7.66,12.59-8.6,13.16s-4.07.55-4.07.55l6.84,4.55.73-1.9s7-7.14,9.57-9.46S686.19,419.16,683.63,422.93Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M667.83,441.84s-.43,1.19.37,1.57l.81.38a1.06,1.06,0,0,0,.58.85.71.71,0,0,0,.88,0s.11.73.67.75a1.39,1.39,0,0,0,.85-.23s-.12,1.24.76,1.11a2.81,2.81,0,0,0,1.8-1.11,5.69,5.69,0,0,0-2.91-3.14c-1.75-.68-2.27-1.22-2.72-1A4.67,4.67,0,0,0,667.83,441.84Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M689.24,407.52s-3.39,10.2-4.64,12.44-2.73,4.66-2.73,4.66.85,3.27,3.35,4.48a9.93,9.93,0,0,0,3.13,1.2s3.81-3.43,4.4-4.85-1-11.54-1-11.54Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M683.23,543.17c-.33,2.73,7.89,2.05,10.11.68s3.94-4.12,5.48-5.31,2.9-1.21,3.09-2.4c0-.35.14-1.34.22-2.69a109.58,109.58,0,0,0,.29-12.73c-.35-5.48.45-18.14-.51-24.66-.15-.93-.25-1.89-.35-2.9-.47-5-.49-10.77-.64-14.18-.18-4.11.8-20.43.8-20.43s1-18.85,1-23.29c0-1.5-1.21-2.32-2.84-2.73-3.18-.86-7.95-.18-7.95-.18-5.65,26.71-3.37,41.78-3.25,50.19.11,7.54,2.22,12.33,3.09,20.71s2.56,20.21,2.22,24.5c-.23,2.88-4.9,7.65-8,11.27C684.5,540.78,683.35,542.26,683.23,543.17Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M690.51,432s-2.43,14.6-3.13,24.53-.9,28.15,1.14,33.57S693,524.83,693,524.83s5.13,4.28,9.77,0v-53.1l4.3-36.65-4.92-6.62Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M695,453.25c1.73,5.3,6.87,5.81,6.17,14.39s-1.19,18.66.18,24.82c.07.23.11.48.17.7v0a141.69,141.69,0,0,1,3.94,22.92c1,11.65,1,23.47.68,26.37-.16,1.35-.88,4.19-1.46,7-.7,3.27-1.23,6.53-.59,7.54,1.19,1.87,8.38,0,9.41-1.73s.7-5.46.7-7.52c0-.37.06-1.72.18-3.74.54-9.17,2-32,1.69-37.36-.33-6.52-2.22-16.8-1.71-24.15s3.09-13.2,2.22-26-5.65-13.88-6-20.56c-.22-4.17-6.22-4.07-10.73-3.41h0a46.26,46.26,0,0,0-4.85,1S693.34,447.92,695,453.25Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M694.29,435.08s-1,12.59,0,16.79,4.71,8,5.4,9.93.25,20.81.25,23.64a52.94,52.94,0,0,0,2.06,11.9,84.77,84.77,0,0,1,2.83,16.87c0,4.2,1.37,17.73,1.11,20.81a6.53,6.53,0,0,0,4.88,1.8,6.86,6.86,0,0,0,4.88-1.63s1.29-24.32.77-30.83-1.62-16.95-1.45-20.64,2.48-11.56,3-19.61a59,59,0,0,0-1.54-16.1L712,435.08s-2.57-5-2.91-5l-12,.25Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M723.07,411.34c-1.15-7.51-4.11-9.63-10.79-14.77s-14.19-7.77-18-1.8-5.72,13.94-5.72,15.35,2.31,4.69,2.25,6.55-.26,15.29-.26,15.29,2,5.14,11,5.72,9.89-.77,9.89-.77,1.16-7.07,2-11.24S723.86,416.44,723.07,411.34Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M711.45,436.91s-.84,1.34-9.89.77-11-5.72-11-5.72.19-13.42.26-15.29-2.25-5.13-2.25-6.55,1.86-9.37,5.72-15.35a6.92,6.92,0,0,1,5.37-3.37c-.31.37-3.87,4.67-3.79,7.29s8,8.14,11.22,8.14,4.93-5.34,9.34-7c3.86,3.2,5.81,5.8,6.69,11.55.79,5.1-8.79,10.15-9.63,14.33S711.45,436.91,711.45,436.91Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M699.56,400c5.14,2.1,7.46-.65,9.38-2.06a27.15,27.15,0,0,1,3.47-2.18s8.22,6.81,9.76,9.5.52,10.15-2.57,14.13-5.51,3.06-6.16,6.29-1.54,8.61-.64,11.06,3.72,8.47,4.62,14.25c0,0-5.4-4.62-8.73-3.46s-6.81,7.45-12,7.57-8.86-6.42-9.12-7.83,2.44-16.83,2.44-24.15-2.44-11.69-2.06-14.52,3.77-10.87,5.14-13,6.42-2.23,6.42-2.23S696.74,398.83,699.56,400Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M699.5,390.79s.07,5.46.26,7.07,4.62,1.6,6.55,1.6a3.1,3.1,0,0,0,3.34-3.08c.07-1.86,0-10.45,0-10.45a26,26,0,0,0-6.25,2.23C699.63,390,699.5,390.79,699.5,390.79Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M695.05,372.57c-.6,1.88,0,4.54-.17,5.4a11.78,11.78,0,0,0-.69,3.08c0,1.37-.08,8.65,1.37,9.59s9.51-.34,11.14-1.63a17.5,17.5,0,0,0,2.91-3.08,3.5,3.5,0,0,0,2.91-1.28A17,17,0,0,0,714.58,371c-1.89-6.34-12.08-6.59-15.68-4S695.05,372.57,695.05,372.57Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M683.23,543.17c-.33,2.73,7.89,2.05,10.11.68s3.94-4.12,5.48-5.31,2.9-1.21,3.09-2.4c0-.35.14-1.34.22-2.69-3,2.24-10.4,7.44-13.17,7.07-1.73-.25-2.61-.81-3-1.5C684.5,540.78,683.35,542.26,683.23,543.17Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M704.13,557c1.19,1.87,8.38,0,9.41-1.73s.7-5.46.7-7.52c0-.37.06-1.72.18-3.74-.2.82-.39,1.71-.53,2.61-.6,3.87-.95,5.41-5.82,6-2.13.27-3-1.31-3.35-3.16C704,552.77,703.49,556,704.13,557Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M723.82,416.5c-.68-6.42-1.19-11.13-4.53-11.73s-5.4,3.6-4.54,10.62,2.31,16.19,2.31,16.19-2,23.12-2.23,24-1.88,1.46-2.65,2.57-1.89,5.65-1.12,6.08,1.63-2.31,2.23-2,.09,3.09-.34,4.28-1.54,2.49-.86,2.92,4.63-.95,5.74-2.92,1.71-7.19,1.63-8.64,4.62-23.21,4.88-24.84S723.82,416.5,723.82,416.5Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M723.65,409.05c-.82-3.95-2.57-6.16-6.6-5.48s-4.79,7.45-3.68,12.68,2.91,15.07,2.91,15.84-.77,9.59-.77,9.59a9.08,9.08,0,0,0,7.45,1.8s2.06-8.57,2.06-10.62S725.19,416.5,723.65,409.05Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M699.67,394.67a3.8,3.8,0,0,0-2.66,3,5.34,5.34,0,0,1,.09-3.17,9.65,9.65,0,0,1,2.51-3.09Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M696.2,370s2.57,8.1,12.33,12.34c0,0,1.22-4.24,3.15-2.89s1.86,3.14,1.15,4.24-1.57,2.54-3.22,2.2c.52.11-.66,6.94-.8,7.46-.73,2.7-2.19,4.79-3.22,7.29-1.48,3.62-1.11,8.23-1.11,12.09-.21-1.74,2.08-5.58,3.39-6.62.07.88,0,1.79,0,2.68,0-2.13,2.2-5.23,3.34-6.89,1.54-2.25,3.14-4.05,5.84-2.6.3-8.55,1.59-18.11-.89-26.43-2.23-7.45-7.54-8.47-11.57-7.36S696.2,370,696.2,370Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M708.27,365.36c-3.08-1.74-6.55-1.1-9,.06s-4.37,3.4-4.69,4.95a21.17,21.17,0,0,0,.22,5.07,43.12,43.12,0,0,1,.74-4.3c.32-1,.71-1.1.71-1.1a43.2,43.2,0,0,1,5.81-3.53C706.09,364.75,708.27,365.36,708.27,365.36Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M694.53,370.37c-.94,6.88-1.77,13.17-1,19.6s1.15,12.71,1.15,12.71l5-7.12-.19-4.77s-3.18.31-3.94-.15-1.39-5.55-1.35-7-.17-3.21.26-4.15a5.58,5.58,0,0,0,.47-1.84l-.13-3Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M397.42,522.94s10.93-3.12,13.28-2,.54,5.71-4.54,8.6-7.82,4.69-10.51,5.39-6.91.78-7.54-1.88-.31-5.86.39-7S397.42,522.94,397.42,522.94Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M398.4,522.22v2.42a4.91,4.91,0,0,1-4.88,3.42c-4.49,0-4.59-2.37-4.59-2.37l.13-3.36",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M413,532.45s12.26-3.51,14.89-2.2.61,6.4-5.09,9.65-8.77,5.26-11.79,6-7.75.88-8.45-2.1-.35-6.57.43-7.89S413,532.45,413,532.45Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M413,531v4.39s-.54,2.89-4.83,3.15S403,536,403,536v-3.4l6.49-1Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M388.15,442.76c-1.17,5.6,2.13,12.08,2.31,14.54S388.83,478,387.77,491s-.14,33.74-.14,33.74a5.88,5.88,0,0,0,6,1.93,15.16,15.16,0,0,0,6.53-2.8S403.08,480.09,404,475s2.4-25.42,2.51-28.57S390.55,431.28,388.15,442.76Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M422.4,448.24c.31,19.05-2.67,39.21-3,41.49s-3.79,43.65-3.79,43.65-3.57,8.07-14.79,2c0,0,1.16-37.89,1.37-44.33s1.25-19.75.81-26.41-4.18-8.42-4.58-17.18c0,0,1.46-8.07,12-7.36S422.4,448.24,422.4,448.24Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M426.14,399.58c1.26-7.61-2.87-11.82-12.09-17.22-3.82-2.24-18-12-25-3.29s.39,28.14,0,39.18S387,443.76,387,443.76s3.55,7.23,16.44,8.41,21-2.36,21-2.36S422.46,421.93,426.14,399.58Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M417.33,356.06s1.41,5.17,1.67,6.22a10.06,10.06,0,0,1,0,3.25c-.09.7,1.14,2.63,1,3.5s-1,6.14-2.63,7.63-4.73,1-4.73,1,.26,4.65,0,5.26-7.45.09-10.43-1.66-1.93-6.49-1.93-6.49l7.63-18.67Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M417.33,356.06a15.34,15.34,0,0,0,0-6.31c-.78-2.63-7.88-2.37-10.38-1.58s-11.31,3.68-11.84,5.79a8.49,8.49,0,0,0,0,3.94s-1.71,2.89-1.44,4.6,6.57,12.23,6.57,12.23,4,.53,5.42-.66,2.73-5.78,4.57-6.31,2.5,2.89,2.5,2.89l1.19-.92s-.66-3.81.13-5.12a11.62,11.62,0,0,1,2-2.37l-1-4.08Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M440,452c-.26-.84-2.93-8.36-2.93-8.36l-8.64-21.75a10.77,10.77,0,0,0-2.23-3.59c.5-8.26-1.63-22.82-1.63-22.82s-7.86-5.42-10.38,3.89c0,0,.89,14.5,1.16,20.63v0l0,.67c0,.76.05,1.35.05,1.69a2,2,0,0,0,.08.56v0l0,.08a1.56,1.56,0,0,0,.2.41l0,.07v0c3.09,6.25,14.64,23.31,14.79,24.11,0,0-.57,2.91.4,4s2,1.22,2.19,2,.08,3.85.27,4.65,3.5,3.93,4.74,3.05c0,0,1-2.88,1.3-3.68S440.26,452.8,440,452Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M428.51,445.73l1.35,2.17s3.08.81,5.27-.33a4,4,0,0,0,2.38-2.71l-1-2.59Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M413.76,395.16c2.69-9.22,11.12-6.21,12.31-2.2.64,2.16.9,8.2,1,13.34,0,.08,0,.18,0,.26,0,.53,0,1.05,0,1.56,0,.09,0,.17,0,.27v0c0,1.33,0,2.52,0,3.5.39,8.89,3.41,10.87,3.76,13.57.39,3,5.65,16.79,5.65,16.79a8.3,8.3,0,0,1-8,3.46s-3.42-1.05-4.4-2.58-9.4-17.67-9.93-19.11-.53-5.79-1.18-17.22h0A34.19,34.19,0,0,1,413.76,395.16Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M400.24,374.73s.74,4.34,6.59,5.26,6.51.13,6.51.13l1.52,4.41a22.67,22.67,0,0,1-10.59-1.71c-4.86-2.31-5.26-4.28-5.59-5.13S400.24,374.73,400.24,374.73Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M348.36,162.47c-2.1-5.29-5.77-8.1-9-6.11s1.8,16.33,3.41,21.29,2.16,7.86,3.62,9S361.46,204,361.46,204s-.91,4-.28,6,1.47,4.35,2.14,4.08.4-3.55.95-3.65,1.13,2.95,1,3.83-2.1,4.13-1.56,4.83,3-1.21,4.15-2.67a7.1,7.1,0,0,0,1.62-4.55c-.12-1.1-.51-3.49-.51-3.49l-3-5.65-10.76-19.32Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M350.65,169.45s3.53,10.63,4.83,13,2.84,4.86,2.84,4.86a9.06,9.06,0,0,1-3.84,4.33l-2.61,1.26s-4.28-3.25-4.89-4.73,1-12,1-12Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M358.32,187.28a2.25,2.25,0,0,1,1.44,2.29,9.18,9.18,0,0,1-2.34,3.26,10.7,10.7,0,0,1-4.26,2.45,8.35,8.35,0,0,1-2-3.05,29.91,29.91,0,0,0,4.85-2.84Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M356.91,310.84c.34,2.85-8.23,2.14-10.54.71s-4.11-4.29-5.72-5.53-3-1.26-3.21-2.51c-.05-.36-.15-1.39-.24-2.8a116.5,116.5,0,0,1-.3-13.26c.37-5.72-.47-18.92.54-25.71.15-1,.25-2,.36-3,.49-5.21.52-11.23.67-14.78.19-4.29-.84-21.3-.84-21.3s-1.07-19.64-1.07-24.27c0-1.56,1.26-2.42,3-2.85,3.32-.9,8.29-.19,8.29-.19,5.89,27.85,3.51,43.55,3.38,52.31-.11,7.86-2.31,12.86-3.21,21.6s-2.68,21.06-2.32,25.53c.24,3,5.1,8,8.36,11.74C355.58,308.35,356.78,309.9,356.91,310.84Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M344.59,217.11c-1.8,5.53-7.15,6.07-6.42,15s1.24,19.45-.2,25.88c-.06.23-.1.49-.17.73v0a148,148,0,0,0-4.11,23.89c-1.07,12.14-1.07,24.46-.71,27.48.17,1.42.92,4.37,1.52,7.33.73,3.4,1.29,6.81.62,7.86-1.24,1.95-8.74,0-9.81-1.8s-.73-5.7-.73-7.84c0-.39-.06-1.8-.19-3.9-.56-9.55-2.06-33.4-1.76-38.95.35-6.79,2.32-17.5,1.78-25.17s-3.21-13.75-2.31-27.14S328,206,328.33,199.08c.24-4.35,6.49-4.25,11.19-3.56h0a49.49,49.49,0,0,1,5,1S346.37,211.57,344.59,217.11Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M349.32,194.93s-4.33,6.42-21,4.15c0,0-7.28,8.43-7.68,17.94s.81,24.37.81,24.37,5.89,2.54,17,2.54,14.33-3.48,14.33-3.48-.67-27.58-1.34-34.68A43.76,43.76,0,0,0,349.32,194.93Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M315.37,173.44c1.21-7.84,4.29-10.05,11.25-15.4s14.8-8.1,18.81-1.88,6,14.53,6,16-2.41,4.89-2.34,6.83.27,15.94.27,15.94-2.08,5.35-11.52,5.95-10.31-.8-10.31-.8-1.2-7.36-2.07-11.72S314.56,178.75,315.37,173.44Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M327.49,200.08s.87,1.41,10.31.8,11.52-5.95,11.52-5.95-.2-14-.27-15.94,2.34-5.35,2.34-6.83-1.94-9.77-6-16a7.26,7.26,0,0,0-5.6-3.52c.33.4,4,4.88,3.95,7.61s-8.39,8.48-11.69,8.48-5.14-5.57-9.74-7.34c-4,3.34-6.05,6.05-7,12.05-.81,5.31,9.18,10.57,10.05,14.92S327.49,200.08,327.49,200.08Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M339.94,152s-.06,5.69-.26,7.37-4.82,1.67-6.83,1.67a3.23,3.23,0,0,1-3.48-3.21c-.07-1.94,0-10.89,0-10.89a26.91,26.91,0,0,1,6.52,2.32C339.81,151.14,339.94,152,339.94,152Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M335.84,158.46s1.08,2.95,1.79,4.82,3.39,31,2.32,40.79-3.39,13.39-5.35,13.93-13.93-5.36-13.93-5.36,5-12.49,4.64-17.13-6.07-13.22-8-20-1.16-7.41-.18-9.37,7-7.77,7-7.77l7.86,1.07Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M335.84,158.46s-1.6,3.84-1.6,5.09-10.18-5.18-10.18-5.18l.54-2.76Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M344.59,133c.62,2,0,4.73.17,5.63a12.18,12.18,0,0,1,.72,3.21c0,1.43.09,9-1.43,10s-9.91-.36-11.6-1.7a18.15,18.15,0,0,1-3-3.21,3.63,3.63,0,0,1-3-1.34,17.65,17.65,0,0,1-2.15-14.19c2-6.61,12.59-6.88,16.34-4.2S344.59,133,344.59,133Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M356.91,310.84c.34,2.85-8.23,2.14-10.54.71s-4.11-4.29-5.72-5.53-3-1.26-3.21-2.51c-.05-.36-.15-1.39-.24-2.8,3.15,2.33,10.84,7.75,13.73,7.37,1.8-.26,2.72-.84,3.09-1.57C355.58,308.35,356.78,309.9,356.91,310.84Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M335.12,325.3c-1.24,1.95-8.74,0-9.81-1.8s-.73-5.7-.73-7.84c0-.39-.06-1.8-.19-3.9.21.86.41,1.78.56,2.72.62,4,1,5.64,6.06,6.26,2.23.28,3.15-1.37,3.49-3.3C335.23,320.84,335.79,324.25,335.12,325.3Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M314.59,178.81c.72-6.69,1.25-11.6,4.73-12.23s5.63,3.75,4.73,11.07-2.41,16.87-2.41,16.87,2.06,24.1,2.33,25,2,1.51,2.76,2.68,2,5.89,1.16,6.33-1.69-2.41-2.32-2.05-.09,3.21.36,4.46,1.61,2.59.89,3-4.82-1-6-3-1.78-7.5-1.69-9-4.82-24.19-5.09-25.89S314.59,178.81,314.59,178.81Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M314.78,171.05c.85-4.13,2.68-6.43,6.87-5.72s5,7.77,3.84,13.22-3,15.71-3,16.51.8,10,.8,10a9.48,9.48,0,0,1-7.77,1.87s-2.14-8.93-2.14-11.07S313.17,178.81,314.78,171.05Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M323.08,203c-1.52,1-4.46,3.21-8.08,1.83a4.29,4.29,0,0,0-.13,1.83,3.33,3.33,0,0,0,.62,1.65,8.68,8.68,0,0,0,8.26-2,5.37,5.37,0,0,0-.18-2A5.89,5.89,0,0,0,323.08,203Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M339.77,156.05a53.06,53.06,0,0,1,4.55,6.87,25.87,25.87,0,0,1,2.95,10.45c0,1.74,1.52,20.13,2.32,26.42s2.23,14.68,2.23,14.68,2.81.67,1.74-9.37-3.48-20.62-3.34-24.5,2.54-5.09,2.27-9-5.84-16.29-8.17-17.63a10.1,10.1,0,0,0-4.49-1.36Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M339.77,156.05a4,4,0,0,1,2.77,3.13,5.53,5.53,0,0,0-.09-3.31,10.12,10.12,0,0,0-2.62-3.23Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M343.39,130.39s-2.68,8.43-12.86,12.85c0,0-1.27-4.42-3.28-3s-1.94,3.28-1.2,4.42,1.64,2.65,3.36,2.3c0,0,.15,7.94,0,9.41s-7.83,4.56-7.83,4.56-1.41-19.78.91-27.54,7.86-8.84,12.06-7.68S343.39,130.39,343.39,130.39Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M330.8,125.5c3.22-1.81,6.83-1.14,9.44.07s4.55,3.55,4.89,5.15a22.12,22.12,0,0,1-.24,5.29,43.3,43.3,0,0,0-.77-4.48c-.33-1.07-.73-1.14-.73-1.14a45.36,45.36,0,0,0-6.06-3.68C333.08,124.87,330.8,125.5,330.8,125.5Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "673.57 599.39 770.77 542.9 867.46 598.72 770.25 655.21 673.57 599.39"
  }), /*#__PURE__*/React.createElement("image", {
    width: 226,
    height: 131,
    transform: "translate(657.46 533.94)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-223",
    x1: 770.49,
    y1: 599.81,
    x2: 770.47,
    y2: 603.77
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "673.47 588.18 770.68 531.69 770.67 535.66 673.46 592.15 673.47 588.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "673.47 588.18 770.68 531.69 867.36 587.52 770.16 644 673.47 588.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-225",
    points: "770.16 644 673.47 588.18 673.57 556.1 770.25 611.92 770.16 644 673.47 588.18 673.46 592.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "770.25 611.92 867.46 555.43 867.36 587.52 770.16 644 770.25 611.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "673.57 556.1 770.77 499.61 867.46 555.43 770.25 611.92 673.57 556.1"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "709.37 595.47 709.36 598.28 689.22 586.65 689.23 583.84 709.37 595.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "709.44 589.43 709.43 592.24 689.28 580.6 689.29 577.79 709.44 589.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M753.1,580.17a4.39,4.39,0,0,1,2,3.44c0,1.26-.9,1.77-2,1.13a4.34,4.34,0,0,1-2-3.43C751.11,580.05,752,579.54,753.1,580.17Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M748.78,569.89l31.66,18.28,0,14.05-31.66-18.28Zm29.35,22.35v-2.81L758,577.79v2.81l20.15,11.64m-.07,6v-2.81l-20.14-11.63v2.81l20.14,11.63m-25-13.54c1.11.64,2,.13,2-1.13a4.39,4.39,0,0,0-2-3.44c-1.1-.63-2-.12-2,1.14a4.34,4.34,0,0,0,2,3.43m.07-6c1.1.64,2,.12,2-1.14a4.35,4.35,0,0,0-2-3.44c-1.1-.63-2-.12-2,1.14a4.35,4.35,0,0,0,2,3.44",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M753.17,574.13a4.35,4.35,0,0,1,2,3.44c0,1.26-.89,1.78-2,1.14a4.35,4.35,0,0,1-2-3.44C751.18,574,752.07,573.5,753.17,574.13Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M800.4,599.69a6,6,0,0,1,2.72,4.72c0,1.73-1.23,2.44-2.74,1.57a6.06,6.06,0,0,1-2.73-4.73C797.66,599.52,798.88,598.82,800.4,599.69Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M812.67,606.78a6,6,0,0,1,2.73,4.72c0,1.73-1.23,2.44-2.75,1.56a6,6,0,0,1-2.72-4.72C809.93,606.6,811.16,605.91,812.67,606.78Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M825,613.87a6,6,0,0,1,2.72,4.72c0,1.72-1.23,2.44-2.74,1.56a6.06,6.06,0,0,1-2.73-4.72C822.21,613.69,823.45,613,825,613.87Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M800.37,607.46a6,6,0,0,1,2.73,4.71c0,1.74-1.23,2.44-2.74,1.57a6,6,0,0,1-2.73-4.72C797.63,607.29,798.86,606.59,800.37,607.46Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M812.65,614.55a6,6,0,0,1,2.73,4.71c0,1.74-1.24,2.44-2.75,1.57a6,6,0,0,1-2.72-4.73C809.91,614.38,811.14,613.68,812.65,614.55Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M824.93,621.64a6,6,0,0,1,2.72,4.71c0,1.74-1.23,2.44-2.74,1.56a6,6,0,0,1-2.73-4.72C822.19,621.47,823.42,620.77,824.93,621.64Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M753.07,608.74",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M753.07,608.74",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "831.3 593.57 831.31 596.38 851.45 584.76 851.44 581.95 831.3 593.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "831.24 587.53 831.24 590.34 851.39 578.71 851.38 575.9 831.24 587.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M925,578.28a4.39,4.39,0,0,0-2,3.44c0,1.26.9,1.77,2,1.13a4.34,4.34,0,0,0,2-3.43C927,578.15,926.07,577.64,925,578.28Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M929.33,582.05l-31.66,18.27,0-14L929.29,568Zm-29.39,8.29,20.15-11.63V575.9l-20.15,11.63v2.81m.07,6,20.14-11.62V582L900,593.57v2.81m25-13.53a4.34,4.34,0,0,0,2-3.43c0-1.27-.89-1.78-2-1.14a4.39,4.39,0,0,0-2,3.44c0,1.26.9,1.77,2,1.13m-.07-6a4.36,4.36,0,0,0,2-3.45c0-1.26-.89-1.77-2-1.13a4.34,4.34,0,0,0-2,3.43c0,1.26.89,1.78,2,1.15",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M924.9,572.24a4.34,4.34,0,0,0-2,3.43c0,1.26.89,1.78,2,1.15a4.36,4.36,0,0,0,2-3.45C926.89,572.11,926,571.6,924.9,572.24Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M877.67,597.8a6,6,0,0,0-2.72,4.72c0,1.72,1.23,2.44,2.74,1.56a6,6,0,0,0,2.73-4.72C880.41,597.62,879.19,596.92,877.67,597.8Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M865.4,604.88a6,6,0,0,0-2.73,4.73c0,1.72,1.23,2.43,2.75,1.56a6,6,0,0,0,2.72-4.72C868.14,604.71,866.91,604,865.4,604.88Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M853.12,612a6,6,0,0,0-2.72,4.72c0,1.73,1.23,2.44,2.74,1.57a6.07,6.07,0,0,0,2.73-4.72C855.86,611.8,854.63,611.1,853.12,612Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M877.7,605.57a6,6,0,0,0-2.73,4.71c0,1.74,1.23,2.44,2.74,1.56a6,6,0,0,0,2.73-4.72C880.44,605.4,879.21,604.7,877.7,605.57Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M865.42,612.66a6,6,0,0,0-2.73,4.71c0,1.74,1.24,2.43,2.75,1.56a6,6,0,0,0,2.72-4.72C868.16,612.48,866.93,611.78,865.42,612.66Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M853.14,619.74a6,6,0,0,0-2.72,4.71c0,1.74,1.23,2.44,2.74,1.57a6.06,6.06,0,0,0,2.73-4.72C855.88,619.57,854.65,618.88,853.14,619.74Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "839.57 551.14 839.54 558.53 770.08 598.89 770.1 591.5 839.57 551.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "770.1 591.5 770.08 598.89 700.16 558.53 700.18 551.14 770.1 591.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "839.57 551.14 770.1 591.5 700.18 551.14 769.65 510.77 839.57 551.14"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "839.48 547.44 872.3 274.61 667.41 274.61 700.23 547.44 700.16 547.48 770.08 587.85 839.54 547.48 839.48 547.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M838.37,400c-2.61-1.51-4.73-.31-4.74,2.69a10.38,10.38,0,0,0,4.71,8.16c2.59,1.5,4.72.29,4.73-2.71A10.35,10.35,0,0,0,838.37,400Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M845.63,397.25a21.21,21.21,0,0,0-7.23-7.53c-2.82-1.63-5.38-1.82-7.27-.85l2.72,4.87c1.19-.62,2.77-.5,4.53.52a13.11,13.11,0,0,1,4.52,4.7Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M838.45,370.63c-7.28-4.2-13.88-4.71-18.76-2.17l2.72,4.85c4.18-2.17,9.81-1.73,16,1.86s11.82,9.64,16,16.62l2.73-1.7C852.3,381.93,845.72,374.83,838.45,370.63Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M851.32,393.72c-3.35-5.64-7.89-10.54-12.9-13.43s-9.56-3.24-12.93-1.48l2.71,4.85c2.66-1.38,6.25-1.12,10.21,1.17a29.78,29.78,0,0,1,10.17,10.59Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M869.51,408.67c-.06,19.73-14.06,27.71-31.22,17.8s-31.08-34-31-53.73S821.33,345,838.5,355,869.57,389,869.51,408.67Zm-31.21,15c15.83,9.14,28.74,1.77,28.79-16.42s-12.78-40.4-28.6-49.53-28.75-1.79-28.8,16.39,12.79,40.42,28.61,49.56",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M838.29,540.09a.85.85,0,0,1-.86-.86V536a.87.87,0,1,1,1.73,0v3.22A.86.86,0,0,1,838.29,540.09Zm0-6.44a.86.86,0,0,1-.86-.86v-3.23a.87.87,0,0,1,1.73,0v3.23A.87.87,0,0,1,838.29,533.65Zm0-6.44a.86.86,0,0,1-.86-.87v-3.22a.87.87,0,0,1,1.73,0v3.22A.87.87,0,0,1,838.29,527.21Zm0-6.45a.85.85,0,0,1-.86-.86v-3.22a.87.87,0,1,1,1.73,0v3.22A.86.86,0,0,1,838.29,520.76Zm0-6.44a.86.86,0,0,1-.86-.86v-3.23a.87.87,0,0,1,1.73,0v3.23A.87.87,0,0,1,838.29,514.32Zm0-6.44a.86.86,0,0,1-.86-.87v-3.22a.87.87,0,0,1,1.73,0V507A.87.87,0,0,1,838.29,507.88Zm0-6.45a.85.85,0,0,1-.86-.86v-3.22a.87.87,0,1,1,1.73,0v3.22A.86.86,0,0,1,838.29,501.43Zm0-6.44a.86.86,0,0,1-.86-.86V490.9a.87.87,0,0,1,1.73,0v3.23A.87.87,0,0,1,838.29,495Zm0-6.44a.86.86,0,0,1-.86-.87v-3.22a.87.87,0,0,1,1.73,0v3.22A.87.87,0,0,1,838.29,488.55Zm0-6.44a.86.86,0,0,1-.86-.87V478a.87.87,0,1,1,1.73,0v3.22A.87.87,0,0,1,838.29,482.11Zm0-6.45a.86.86,0,0,1-.86-.86v-3.22a.87.87,0,1,1,1.73,0v3.22A.87.87,0,0,1,838.29,475.66Zm0-6.44a.86.86,0,0,1-.86-.87v-3.22a.87.87,0,0,1,1.73,0v3.22A.87.87,0,0,1,838.29,469.22Zm0-6.44a.86.86,0,0,1-.86-.87v-3.22a.87.87,0,1,1,1.73,0v3.22A.87.87,0,0,1,838.29,462.78Zm0-6.45a.85.85,0,0,1-.86-.86v-3.22a.87.87,0,1,1,1.73,0v3.22A.86.86,0,0,1,838.29,456.33Zm0-6.44a.86.86,0,0,1-.86-.87V445.8a.87.87,0,0,1,1.73,0V449A.87.87,0,0,1,838.29,449.89Zm0-6.44a.86.86,0,0,1-.86-.87v-3.22a.87.87,0,1,1,1.73,0v3.22A.87.87,0,0,1,838.29,443.45Zm0-6.45a.85.85,0,0,1-.86-.86v-3.22a.87.87,0,1,1,1.73,0v3.22A.86.86,0,0,1,838.29,437Zm0-6.44a.86.86,0,0,1-.86-.87v-3.22a.87.87,0,0,1,1.73,0v3.22A.87.87,0,0,1,838.29,430.56Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 769.72,
    cy: 536.03,
    r: 4.69
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M400.34,68.16l119.44,69-.2,72.54-119.45-69Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "438.9 144.63 438.9 147.04 345.96 93.39 345.97 90.97 438.9 144.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "387.06 155.26 387.05 157.68 344.73 133.24 344.74 130.82 387.06 155.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "420.42 161 420.41 163.41 344.77 119.74 344.77 117.32 420.42 161"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "437.75 157.48 437.74 159.9 344.81 106.25 344.81 103.82 437.75 157.48"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M577.64,0l63.61,36.73-.11,38.63L577.53,38.63Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "566.07 40.72 566.06 42.01 516.57 13.44 516.57 12.15 566.07 40.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "538.46 46.38 538.45 47.67 515.91 34.66 515.92 33.37 538.46 46.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "556.22 49.44 556.22 50.73 515.93 27.47 515.94 26.18 556.22 49.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "565.45 47.56 565.45 48.86 515.96 20.28 515.96 18.99 565.45 47.56"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "31.32 500.69 126.35 445.46 220.87 500.03 125.84 555.26 31.32 500.69"
  }), /*#__PURE__*/React.createElement("image", {
    width: 221,
    height: 129,
    transform: "translate(15.46 435.94)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "31.04 455.84 126.07 400.61 126.06 404.49 31.03 459.71 31.04 455.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "31.14 422.54 126.17 367.32 126.15 371.19 31.13 426.42 31.14 422.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "31.23 389.25 126.26 334.02 126.25 337.9 31.22 393.12 31.23 389.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "31.03 459.71 126.06 404.49 220.58 459.06 125.55 514.28 31.03 459.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "125.55 514.28 220.58 459.06 220.49 490.42 125.46 545.65 125.55 514.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "31.04 455.84 126.07 400.61 220.59 455.18 125.56 510.41 31.04 455.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "31.13 426.42 126.15 371.19 220.68 425.76 125.65 480.99 31.13 426.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "31.14 422.54 126.17 367.32 220.69 421.89 125.66 477.11 31.14 422.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "31.22 393.12 126.25 337.9 220.77 392.47 125.74 447.69 31.22 393.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "31.23 389.25 126.26 334.02 220.78 388.59 125.75 443.82 31.23 389.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "125.84 412.45 125.75 443.82 31.23 389.25 31.22 393.12 125.74 447.69 125.66 477.11 31.14 422.54 31.13 426.42 125.65 480.99 125.56 510.41 31.04 455.84 31.03 459.71 125.55 514.28 125.46 545.65 30.94 491.07 31.32 357.88 125.84 412.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "125.56 510.41 125.55 514.28 31.03 459.71 31.04 455.84 125.56 510.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-243",
    points: "125.56 510.41 220.59 455.18 220.58 459.06 125.55 514.28 125.56 510.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "125.65 480.99 220.68 425.76 220.59 455.18 125.56 510.41 125.65 480.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "125.66 477.11 220.69 421.89 220.68 425.76 125.65 480.99 125.66 477.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "125.66 477.11 125.65 480.99 31.13 426.42 31.14 422.54 125.66 477.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "125.74 447.69 220.77 392.47 220.69 421.89 125.66 477.11 125.74 447.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "125.75 443.82 220.78 388.59 220.77 392.47 125.74 447.69 125.75 443.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "125.75 443.82 125.74 447.69 31.22 393.12 31.23 389.25 125.75 443.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "125.84 412.45 220.87 357.23 220.78 388.59 125.75 443.82 125.84 412.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "31.32 357.88 126.35 302.66 220.87 357.23 125.84 412.45 31.32 357.88"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "66.32 396.37 66.31 399.12 46.62 387.75 46.63 385 66.32 396.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "66.39 390.46 66.38 393.21 46.68 381.84 46.69 379.09 66.39 390.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M110.61,381.42a4.22,4.22,0,0,1,2,3.36c0,1.23-.88,1.73-2,1.1a4.29,4.29,0,0,1-1.94-3.35C108.67,381.29,109.54,380.8,110.61,381.42Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M106.39,371.37l31,17.86,0,13.74-31-17.87Zm28.69,21.84v-2.75l-19.7-11.37v2.75l19.7,11.37m-.07,5.9v-2.74L115.33,385v2.75L135,399.11M110.6,385.88c1.08.63,2,.13,2-1.1a4.22,4.22,0,0,0-2-3.36c-1.07-.62-1.94-.13-2,1.11a4.29,4.29,0,0,0,1.94,3.35m.07-5.89c1.07.62,2,.11,2-1.12a4.29,4.29,0,0,0-1.94-3.36c-1.07-.62-2-.12-2,1.11a4.32,4.32,0,0,0,1.94,3.37",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M110.68,375.51a4.29,4.29,0,0,1,1.94,3.36c0,1.23-.88,1.74-2,1.12a4.32,4.32,0,0,1-1.94-3.37C108.73,375.39,109.61,374.89,110.68,375.51Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M156.85,400.5a5.83,5.83,0,0,1,2.66,4.61c0,1.69-1.2,2.39-2.68,1.53a5.86,5.86,0,0,1-2.66-4.61C154.17,400.33,155.37,399.64,156.85,400.5Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M168.85,407.43a5.83,5.83,0,0,1,2.66,4.61c0,1.69-1.2,2.38-2.68,1.53a5.86,5.86,0,0,1-2.66-4.62C166.17,407.26,167.37,406.57,168.85,407.43Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M180.85,414.35a5.9,5.9,0,0,1,2.67,4.62c0,1.69-1.21,2.38-2.69,1.53a5.91,5.91,0,0,1-2.66-4.62C178.17,414.18,179.38,413.51,180.85,414.35Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M156.83,408.1a5.82,5.82,0,0,1,2.66,4.6c0,1.7-1.2,2.38-2.68,1.53a5.88,5.88,0,0,1-2.67-4.62C154.15,407.93,155.35,407.24,156.83,408.1Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M168.83,415a5.82,5.82,0,0,1,2.66,4.6c0,1.7-1.2,2.38-2.68,1.53a5.86,5.86,0,0,1-2.66-4.62C166.15,414.85,167.35,414.17,168.83,415Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M180.83,422a5.86,5.86,0,0,1,2.66,4.61c0,1.7-1.2,2.38-2.68,1.53a5.87,5.87,0,0,1-2.66-4.62C178.15,421.78,179.36,421.11,180.83,422Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M110.52,415.23a4.31,4.31,0,0,1,2,3.37c0,1.23-.88,1.73-2,1.1a4.23,4.23,0,0,1-1.94-3.35C108.57,415.11,109.44,414.61,110.52,415.23Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M110.59,409.34a4.25,4.25,0,0,1,1.93,3.36c0,1.23-.87,1.73-2,1.11a4.29,4.29,0,0,1-1.94-3.36C108.64,409.22,109.51,408.72,110.59,409.34Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "66.22 430.19 66.22 432.93 46.53 421.57 46.54 418.82 66.22 430.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "66.29 424.29 66.28 427.04 46.59 415.67 46.59 412.92 66.29 424.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M106.3,405.18l31,17.87,0,13.75-30.95-17.87ZM135,427v-2.75l-19.7-11.37v2.75L135,427m-.06,5.89v-2.74l-19.68-11.37v2.75l19.69,11.36M110.51,419.7c1.08.63,1.95.13,2-1.1a4.31,4.31,0,0,0-2-3.37c-1.08-.62-2-.12-2,1.12a4.23,4.23,0,0,0,1.94,3.35m.06-5.89c1.08.62,2,.12,2-1.11a4.25,4.25,0,0,0-1.93-3.36c-1.08-.62-2-.12-2,1.11a4.3,4.3,0,0,0,1.94,3.36",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M156.73,441.92a5.86,5.86,0,0,1,2.67,4.61c0,1.7-1.21,2.38-2.69,1.53a5.84,5.84,0,0,1-2.66-4.62C154.05,441.74,155.25,441.06,156.73,441.92Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M156.75,434.32a5.86,5.86,0,0,1,2.67,4.61c0,1.7-1.21,2.38-2.69,1.53a5.9,5.9,0,0,1-2.66-4.62C154.08,434.15,155.27,433.46,156.75,434.32Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M168.75,441.24a5.9,5.9,0,0,1,2.67,4.62c0,1.7-1.21,2.38-2.68,1.53a5.88,5.88,0,0,1-2.67-4.62C166.08,441.07,167.28,440.39,168.75,441.24Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M180.73,455.77a5.9,5.9,0,0,1,2.67,4.62c0,1.7-1.2,2.38-2.68,1.53a5.91,5.91,0,0,1-2.67-4.62C178.06,455.6,179.27,454.93,180.73,455.77Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M180.76,448.17a5.89,5.89,0,0,1,2.66,4.62c0,1.7-1.2,2.38-2.68,1.53a5.91,5.91,0,0,1-2.67-4.62C178.08,448,179.29,447.33,180.76,448.17Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M168.73,448.84a5.9,5.9,0,0,1,2.67,4.62c0,1.7-1.21,2.38-2.69,1.53a5.9,5.9,0,0,1-2.66-4.62C166.05,448.67,167.25,448,168.73,448.84Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M110.42,449.06a4.28,4.28,0,0,1,2,3.37c0,1.23-.88,1.73-2,1.1a4.29,4.29,0,0,1-1.94-3.35C108.47,448.94,109.35,448.44,110.42,449.06Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "66.13 464.02 66.12 466.76 46.43 455.4 46.44 452.65 66.13 464.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M106.2,439l31,17.87,0,13.75-31-17.87Zm28.69,21.86v-2.75L115.2,446.75v2.75l19.7,11.37m-.07,5.89V464l-19.69-11.37v2.75l19.69,11.36m-24.41-13.23c1.08.63,2,.13,2-1.1a4.28,4.28,0,0,0-2-3.37c-1.07-.62-2-.12-2,1.12a4.29,4.29,0,0,0,1.94,3.35m.07-5.89c1.07.62,1.94.12,2-1.11a4.29,4.29,0,0,0-1.94-3.36c-1.07-.62-1.95-.12-1.95,1.11a4.26,4.26,0,0,0,1.94,3.36",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M156.63,475.75a5.86,5.86,0,0,1,2.67,4.61c0,1.69-1.2,2.38-2.68,1.53a5.9,5.9,0,0,1-2.67-4.62C154,475.57,155.16,474.89,156.63,475.75Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M156.66,468.15a5.83,5.83,0,0,1,2.66,4.61c0,1.7-1.2,2.38-2.68,1.53a5.88,5.88,0,0,1-2.67-4.62C154,468,155.18,467.29,156.66,468.15Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M168.64,482.67a5.89,5.89,0,0,1,2.66,4.62c0,1.69-1.2,2.38-2.68,1.53A5.9,5.9,0,0,1,166,484.2C166,482.5,167.16,481.82,168.64,482.67Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M168.66,475.07a5.86,5.86,0,0,1,2.66,4.62c0,1.7-1.2,2.38-2.68,1.53A5.84,5.84,0,0,1,166,476.6C166,474.9,167.18,474.22,168.66,475.07Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M180.66,482a5.86,5.86,0,0,1,2.66,4.62c0,1.7-1.2,2.38-2.68,1.53a5.87,5.87,0,0,1-2.66-4.62C178,481.83,179.19,481.16,180.66,482Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M180.64,489.6a5.86,5.86,0,0,1,2.66,4.62c0,1.69-1.2,2.38-2.68,1.53a5.89,5.89,0,0,1-2.66-4.62C178,489.43,179.17,488.76,180.64,489.6Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M110.49,443.17a4.29,4.29,0,0,1,1.94,3.36c0,1.23-.88,1.73-2,1.11a4.26,4.26,0,0,1-1.94-3.36C108.54,443.05,109.42,442.55,110.49,443.17Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "66.2 458.12 66.19 460.87 46.49 449.5 46.5 446.75 66.2 458.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "66.03 497.84 66.02 500.59 46.34 489.23 46.34 486.47 66.03 497.84"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M110.33,482.88a4.27,4.27,0,0,1,1.94,3.38c0,1.23-.87,1.73-2,1.1a4.25,4.25,0,0,1-1.93-3.35C108.38,482.76,109.25,482.26,110.33,482.88Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M110.39,477a4.24,4.24,0,0,1,1.94,3.36c0,1.23-.88,1.73-2,1.11a4.3,4.3,0,0,1-1.94-3.36C108.45,476.87,109.32,476.37,110.39,477Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M106.1,472.85l31,17.86,0,13.74-31-17.87Zm28.62,27.74v-2.75L115,486.47v2.76l19.68,11.36m.07-5.9v-2.75l-19.7-11.37v2.75l19.7,11.37m-24.48-7.33c1.09.63,2,.13,2-1.1a4.27,4.27,0,0,0-1.94-3.38c-1.08-.62-2-.12-2,1.13a4.25,4.25,0,0,0,1.93,3.35m.07-5.9c1.07.62,2,.12,2-1.11a4.24,4.24,0,0,0-1.94-3.36c-1.07-.62-1.94-.12-2,1.11a4.3,4.3,0,0,0,1.94,3.36",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M156.54,509.56a5.87,5.87,0,0,1,2.66,4.62c0,1.7-1.2,2.38-2.68,1.53a5.84,5.84,0,0,1-2.66-4.62C153.86,509.41,155.06,508.71,156.54,509.56Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M156.56,502a5.86,5.86,0,0,1,2.67,4.61c0,1.69-1.21,2.37-2.69,1.52a5.84,5.84,0,0,1-2.66-4.6C153.88,501.81,155.08,501.12,156.56,502Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M168.56,508.91a5.86,5.86,0,0,1,2.67,4.61c0,1.69-1.21,2.37-2.69,1.52a5.88,5.88,0,0,1-2.66-4.61C165.88,508.74,167.08,508.05,168.56,508.91Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M180.54,523.42a5.91,5.91,0,0,1,2.67,4.62c0,1.7-1.21,2.38-2.69,1.53a5.9,5.9,0,0,1-2.66-4.62C177.86,523.26,179.07,522.57,180.54,523.42Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M180.56,515.83a5.9,5.9,0,0,1,2.67,4.62c0,1.69-1.21,2.37-2.68,1.52a5.91,5.91,0,0,1-2.67-4.61C177.89,515.66,179.09,515,180.56,515.83Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M168.54,516.49a5.91,5.91,0,0,1,2.67,4.62c0,1.7-1.21,2.38-2.69,1.53a5.86,5.86,0,0,1-2.66-4.62C165.86,516.33,167.06,515.64,168.54,516.49Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "66.1 491.94 66.09 494.69 46.39 483.31 46.4 480.57 66.1 491.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "185.53 394.52 185.54 397.26 205.22 385.89 205.22 383.15 185.53 394.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "185.46 388.61 185.47 391.36 205.17 379.98 205.16 377.24 185.46 388.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M278.63,379.56a4.31,4.31,0,0,0-1.95,3.37c0,1.23.88,1.73,2,1.1a4.25,4.25,0,0,0,1.93-3.36C280.58,379.44,279.71,378.94,278.63,379.56Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M282.89,383.25l-30.95,17.86,0-13.73,31-17.87Zm-28.72,8.11L273.87,380v-2.74l-19.7,11.37v2.75m.07,5.9,19.68-11.36v-2.75l-19.69,11.37v2.74M278.65,384a4.25,4.25,0,0,0,1.93-3.36c0-1.23-.87-1.73-1.95-1.11a4.31,4.31,0,0,0-1.95,3.37c0,1.23.88,1.73,2,1.1m-.07-5.89a4.32,4.32,0,0,0,1.94-3.37c0-1.24-.88-1.73-1.95-1.11a4.23,4.23,0,0,0-1.94,3.35c0,1.24.87,1.75,1.95,1.13",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M278.57,373.66a4.23,4.23,0,0,0-1.94,3.35c0,1.24.87,1.75,1.95,1.13a4.32,4.32,0,0,0,1.94-3.37C280.51,373.54,279.64,373,278.57,373.66Z",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M232.4,398.64a5.9,5.9,0,0,0-2.67,4.62c0,1.69,1.21,2.38,2.69,1.53a5.89,5.89,0,0,0,2.66-4.62C235.08,398.47,233.88,397.79,232.4,398.64Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M220.4,405.57a5.9,5.9,0,0,0-2.67,4.62c0,1.69,1.21,2.38,2.68,1.53a5.91,5.91,0,0,0,2.67-4.62C223.07,405.4,221.88,404.72,220.4,405.57Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M208.4,412.5a5.9,5.9,0,0,0-2.67,4.62c0,1.69,1.2,2.38,2.68,1.53a5.92,5.92,0,0,0,2.67-4.62C211.07,412.33,209.86,411.65,208.4,412.5Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M232.42,406.24a5.86,5.86,0,0,0-2.66,4.61c0,1.7,1.2,2.38,2.68,1.53a5.86,5.86,0,0,0,2.66-4.62C235.1,406.07,233.9,405.39,232.42,406.24Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M220.42,413.17a5.89,5.89,0,0,0-2.67,4.61c0,1.7,1.21,2.38,2.69,1.53a5.89,5.89,0,0,0,2.66-4.62C223.1,413,221.9,412.32,220.42,413.17Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M208.42,420.1a5.89,5.89,0,0,0-2.67,4.61c0,1.7,1.21,2.38,2.68,1.52a5.87,5.87,0,0,0,2.67-4.61C211.09,419.93,209.89,419.25,208.42,420.1Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M278.73,413.38a4.3,4.3,0,0,0-2,3.36c0,1.24.88,1.74,2,1.11a4.26,4.26,0,0,0,1.94-3.36C280.68,413.26,279.8,412.76,278.73,413.38Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M278.66,407.49a4.29,4.29,0,0,0-1.94,3.35c0,1.24.88,1.74,1.95,1.12a4.25,4.25,0,0,0,1.94-3.36C280.61,407.37,279.73,406.87,278.66,407.49Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "185.62 428.33 185.63 431.08 205.32 419.71 205.31 416.97 185.62 428.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "185.56 422.44 185.56 425.19 205.26 413.81 205.25 411.07 185.56 422.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M283,417.08,252,435l0-13.75L283,403.33Zm-28.73,8.11L274,413.81v-2.74l-19.69,11.37v2.75m.07,5.89L274,419.71V417l-19.69,11.36v2.75m24.41-13.23a4.26,4.26,0,0,0,1.94-3.36c0-1.23-.88-1.73-1.95-1.11a4.3,4.3,0,0,0-2,3.36c0,1.24.88,1.74,2,1.11m-.07-5.89a4.25,4.25,0,0,0,1.94-3.36c0-1.23-.88-1.73-1.95-1.11a4.29,4.29,0,0,0-1.94,3.35c0,1.24.88,1.74,1.95,1.12",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M232.52,440.06a5.9,5.9,0,0,0-2.67,4.62c0,1.7,1.2,2.38,2.68,1.53a5.9,5.9,0,0,0,2.67-4.62C235.19,439.89,234,439.21,232.52,440.06Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M232.49,432.46a5.89,5.89,0,0,0-2.66,4.62c0,1.7,1.2,2.38,2.68,1.53a5.9,5.9,0,0,0,2.67-4.62C235.17,432.29,234,431.61,232.49,432.46Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M220.49,439.39a5.86,5.86,0,0,0-2.66,4.62c0,1.7,1.2,2.38,2.68,1.53a5.9,5.9,0,0,0,2.67-4.62C223.17,439.22,222,438.54,220.49,439.39Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M208.51,453.92a5.84,5.84,0,0,0-2.66,4.62c0,1.7,1.2,2.38,2.68,1.53a5.91,5.91,0,0,0,2.67-4.62C211.19,453.75,210,453.07,208.51,453.92Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M208.49,446.32a5.86,5.86,0,0,0-2.66,4.62c0,1.7,1.2,2.38,2.68,1.53a5.87,5.87,0,0,0,2.66-4.62C211.17,446.15,210,445.47,208.49,446.32Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M220.51,447a5.89,5.89,0,0,0-2.66,4.62c0,1.7,1.2,2.38,2.68,1.53a5.9,5.9,0,0,0,2.67-4.62C223.19,446.82,222,446.14,220.51,447Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M278.82,447.21a4.27,4.27,0,0,0-1.94,3.36c0,1.24.87,1.74,2,1.11a4.29,4.29,0,0,0,1.94-3.36C280.77,447.09,279.9,446.59,278.82,447.21Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "185.72 462.17 185.73 464.91 205.42 453.54 205.41 450.8 185.72 462.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M283.09,450.91l-30.95,17.87,0-13.75,31-17.87ZM254.36,459l19.7-11.38V444.9l-19.7,11.37V459m.07,5.89,19.69-11.37V450.8l-19.69,11.36v2.75m24.41-13.23a4.29,4.29,0,0,0,1.94-3.36c0-1.23-.88-1.73-2-1.11a4.27,4.27,0,0,0-1.94,3.36c0,1.24.87,1.74,2,1.11m-.07-5.89a4.3,4.3,0,0,0,1.94-3.36c0-1.23-.88-1.73-1.95-1.11a4.26,4.26,0,0,0-1.94,3.35c0,1.24.88,1.74,1.95,1.12",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M232.61,473.89a5.86,5.86,0,0,0-2.66,4.62c0,1.69,1.2,2.38,2.68,1.53a5.87,5.87,0,0,0,2.66-4.62C235.29,473.72,234.09,473,232.61,473.89Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M232.59,466.29a5.86,5.86,0,0,0-2.66,4.62c0,1.7,1.2,2.38,2.68,1.53a5.86,5.86,0,0,0,2.66-4.62C235.27,466.12,234.07,465.44,232.59,466.29Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M220.61,480.82a5.86,5.86,0,0,0-2.66,4.62c0,1.69,1.2,2.38,2.68,1.53a5.87,5.87,0,0,0,2.66-4.62C223.29,480.65,222.09,480,220.61,480.82Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M220.59,473.22a5.9,5.9,0,0,0-2.67,4.62c0,1.7,1.21,2.38,2.69,1.53a5.86,5.86,0,0,0,2.66-4.62C223.27,473.05,222.07,472.37,220.59,473.22Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M208.59,480.15a5.9,5.9,0,0,0-2.67,4.62c0,1.7,1.21,2.38,2.69,1.53a5.92,5.92,0,0,0,2.66-4.62C211.27,480,210.06,479.3,208.59,480.15Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M208.61,487.75a5.88,5.88,0,0,0-2.67,4.62c0,1.68,1.21,2.38,2.69,1.53a5.91,5.91,0,0,0,2.66-4.62C211.29,487.58,210.08,486.9,208.61,487.75Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M278.76,441.32a4.26,4.26,0,0,0-1.94,3.35c0,1.24.88,1.74,1.95,1.12a4.3,4.3,0,0,0,1.94-3.36C280.7,441.2,279.83,440.7,278.76,441.32Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "185.65 456.27 185.66 459.02 205.36 447.64 205.35 444.9 185.65 456.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "185.82 495.98 185.82 498.74 205.51 487.38 205.5 484.62 185.82 495.98"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M278.92,481a4.31,4.31,0,0,0-1.95,3.38c0,1.23.88,1.73,2,1.1a4.26,4.26,0,0,0,1.94-3.36C280.87,480.91,280,480.41,278.92,481Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M278.85,475.14a4.25,4.25,0,0,0-1.93,3.35c0,1.24.87,1.74,1.95,1.12a4.27,4.27,0,0,0,1.93-3.36C280.8,475,279.93,474.52,278.85,475.14Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M283.18,484.73l-31,17.86,0-13.73L283.14,471Zm-28.66,14,19.69-11.37v-2.75L254.52,496v2.76m-.06-5.9,19.69-11.38v-2.74l-19.7,11.37v2.75m24.47-7.33a4.24,4.24,0,0,0,1.94-3.36c0-1.24-.88-1.74-1.95-1.12a4.31,4.31,0,0,0-1.95,3.38c0,1.23.88,1.73,2,1.1m-.06-5.9a4.27,4.27,0,0,0,1.93-3.36c0-1.24-.87-1.73-1.95-1.11a4.25,4.25,0,0,0-1.93,3.35c0,1.24.87,1.74,1.95,1.12",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M232.71,507.71a5.91,5.91,0,0,0-2.67,4.62c0,1.7,1.21,2.38,2.69,1.53a5.91,5.91,0,0,0,2.66-4.62C235.39,507.55,234.19,506.86,232.71,507.71Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M232.69,500.12a5.9,5.9,0,0,0-2.67,4.62c0,1.69,1.2,2.37,2.68,1.52a5.89,5.89,0,0,0,2.67-4.61C235.36,500,234.16,499.27,232.69,500.12Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M220.68,507.05a5.91,5.91,0,0,0-2.66,4.62c0,1.69,1.2,2.37,2.68,1.52a5.89,5.89,0,0,0,2.67-4.61C223.36,506.88,222.16,506.2,220.68,507.05Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M208.71,521.57a5.9,5.9,0,0,0-2.67,4.62c0,1.69,1.2,2.38,2.68,1.52a5.87,5.87,0,0,0,2.67-4.61C211.38,521.41,210.17,520.72,208.71,521.57Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M208.68,514A5.86,5.86,0,0,0,206,518.6c0,1.69,1.2,2.37,2.68,1.52a5.91,5.91,0,0,0,2.67-4.61C211.36,513.81,210.15,513.13,208.68,514Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-228",
    cx: 220.72,
    cy: 517.71,
    rx: 3.77,
    ry: 2.18,
    transform: "translate(-406.5 448.41) rotate(-59.84)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "185.75 490.09 185.76 492.84 205.46 481.46 205.45 478.72 185.75 490.09"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "193.6 353.03 193.58 360.25 125.67 399.72 125.7 392.49 193.6 353.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "125.7 392.49 125.67 399.72 57.32 360.25 57.34 353.03 125.7 392.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "193.6 353.03 125.7 392.49 57.34 353.03 125.25 313.57 193.6 353.03"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "193.41 353.27 251.07 87.26 0 87.26 57.65 353.27 57.59 353.31 125.75 392.67 193.48 353.31 193.41 353.27"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M475.68,622.73c4.5,2.6,4.52,6.8.07,9.38L410.57,670c-4.47,2.6-11.71,2.6-16.21,0L239.71,580.25c-4.47-2.58-4.5-6.78,0-9.37L304.86,533c4.45-2.59,11.69-2.59,16.17,0Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 259,
    height: 157,
    transform: "translate(159.46 522.94)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M475.75,612.87l-65.18,37.88a16.53,16.53,0,0,1-8.12,2V662a16.42,16.42,0,0,0,8.09-1.95l65.19-37.88c2.2-1.28,3.31-3,3.31-4.65l0-9.33C479.07,609.91,478,611.59,475.75,612.87Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M475.68,603.49c4.5,2.6,4.52,6.8.07,9.38l-65.18,37.88c-4.47,2.6-11.71,2.6-16.21,0L239.71,561c-4.47-2.58-4.5-6.78,0-9.37l65.18-37.88c4.45-2.59,11.69-2.59,16.17,0Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-267"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M437,621.59a12.22,12.22,0,0,0-11.08,0c-3.05,1.77-3,4.65.05,6.42a12.19,12.19,0,0,0,11,0c3.05-1.77,3-4.64,0-6.4",
    transform: "translate(-68.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M292,532.11a3.24,3.24,0,0,0-2.94,0l-16.28,9.46a.9.9,0,0,0,0,1.71,3.23,3.23,0,0,0,2.95,0L292,533.82c.82-.47.8-1.24,0-1.71",
    transform: "translate(-68.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M394.36,650.75,239.71,561c-2.25-1.3-3.37-3-3.37-4.71l0,9.33c0,1.7,1.12,3.41,3.37,4.71l154.65,89.74a16.55,16.55,0,0,0,8.11,1.95V652.7A16.72,16.72,0,0,1,394.36,650.75Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M446.74,632.94c.55-.31,1-.05,1,.59v.73a2.25,2.25,0,0,1-1,1.75l-6.7,3.86c-.56.33-1,.07-1-.58v-.73a2.25,2.25,0,0,1,1-1.75Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M458.34,625.92c.9-.52,1.61-.11,1.62.91a3.52,3.52,0,0,1-1.61,2.78c-.89.51-1.6.1-1.61-.92A3.5,3.5,0,0,1,458.34,625.92Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M463,623.22c.87-.5,1.61-.1,1.61.92a3.57,3.57,0,0,1-1.6,2.78c-.9.51-1.61.1-1.62-.92A3.52,3.52,0,0,1,463,623.22Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M467.65,620.54c.89-.51,1.61-.1,1.61.92a3.54,3.54,0,0,1-1.6,2.78c-.87.5-1.61.1-1.61-.92A3.52,3.52,0,0,1,467.65,620.54Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M472.31,617.85c.89-.51,1.61-.1,1.61.92a3.54,3.54,0,0,1-1.6,2.78c-.89.51-1.61.1-1.61-.92A3.51,3.51,0,0,1,472.31,617.85Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M413.45,652.27c.89-.52,1.61-.11,1.61.92a3.53,3.53,0,0,1-1.6,2.77c-.9.52-1.61.11-1.62-.92A3.5,3.5,0,0,1,413.45,652.27Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M418.11,649.58c.87-.51,1.61-.11,1.61.91a3.57,3.57,0,0,1-1.6,2.78c-.89.51-1.61.11-1.61-.92A3.48,3.48,0,0,1,418.11,649.58Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M422.75,646.9c.89-.52,1.61-.11,1.61.91a3.54,3.54,0,0,1-1.6,2.78c-.87.5-1.61.11-1.61-.92A3.54,3.54,0,0,1,422.75,646.9Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M427.41,644.21c.89-.52,1.61-.11,1.61.91a3.51,3.51,0,0,1-1.6,2.78c-.89.51-1.61.1-1.61-.92A3.5,3.5,0,0,1,427.41,644.21Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M254.3,573.92l1.11-.64a1.08,1.08,0,0,1,1.11.1l-1.11.65A1.09,1.09,0,0,0,254.3,573.92Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "186.71 574.03 187.82 573.38 197.31 578.86 196.2 579.5 186.71 574.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M267.12,582.6l-1.11.64a1.09,1.09,0,0,0,.46-1,3.51,3.51,0,0,0-1.57-2.74l1.11-.64a3.51,3.51,0,0,1,1.57,2.73A1.11,1.11,0,0,1,267.12,582.6Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M264.9,579.5a3.51,3.51,0,0,1,1.57,2.74c0,1-.72,1.4-1.58.9l-9.49-5.48a3.51,3.51,0,0,1-1.57-2.72c0-1,.72-1.41,1.58-.91Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M270,583.08l1.11-.64a1.08,1.08,0,0,1,1.11.1l-1.11.65A1.11,1.11,0,0,0,270,583.08Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "202.43 583.19 203.54 582.54 213.03 588.02 211.92 588.67 202.43 583.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M282.84,591.76l-1.11.64a1.09,1.09,0,0,0,.46-1,3.48,3.48,0,0,0-1.57-2.73l1.11-.65a3.51,3.51,0,0,1,1.57,2.73A1.1,1.1,0,0,1,282.84,591.76Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M280.62,588.67a3.48,3.48,0,0,1,1.57,2.73c0,1-.72,1.4-1.58.9l-9.49-5.48a3.51,3.51,0,0,1-1.57-2.72c0-1,.72-1.41,1.58-.91Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "215.8 562.57 222.98 566.73 271.63 538.64 264.46 534.48 215.8 562.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M342.72,538.46l-60.8,35.1-9.23-5.37,60.79-35.1Zm-51,28.27,48.65-28.09-7.17-4.17L284.5,562.56l7.18,4.17M285,569.46c1.44-.82,1.44-2.17,0-3a5.71,5.71,0,0,0-5.2,0c-1.46.84-1.46,2.19,0,3a5.74,5.74,0,0,0,5.2,0",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "217.35 545.47 219.15 546.51 227.31 541.8 225.51 540.75 217.35 545.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "186.96 563.01 188.76 564.06 196.92 559.34 195.12 558.3 186.96 563.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "255.68 525.42 253.88 524.38 252.5 525.17 254.3 526.21 255.68 525.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "255.26 523.58 257.05 524.63 257.69 524.25 255.9 523.21 255.26 523.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "251.13 525.96 249.75 526.76 251.55 527.8 252.93 527.01 251.13 525.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "247.73 527.92 249.53 528.97 250.17 528.6 248.38 527.55 247.73 527.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M279.77,566.45c-1.46.84-1.46,2.19,0,3a5.74,5.74,0,0,0,5.2,0c1.44-.82,1.44-2.17,0-3A5.71,5.71,0,0,0,279.77,566.45Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M396.65,574.67c-3.25,1.87-3.26,4.9,0,6.77a12.86,12.86,0,0,0,11.68,0c3.25-1.87,3.26-4.9,0-6.77A12.86,12.86,0,0,0,396.65,574.67Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M379.19,584.75c-3.24,1.87-3.26,4.89,0,6.77a12.88,12.88,0,0,0,11.69,0c3.22-1.87,3.26-4.9,0-6.77A12.85,12.85,0,0,0,379.19,584.75Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.72,594.83c-3.25,1.88-3.26,4.9,0,6.77a12.8,12.8,0,0,0,11.68,0c3.25-1.87,3.26-4.89,0-6.77A12.86,12.86,0,0,0,361.72,594.83Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M344.26,604.91c-3.24,1.87-3.26,4.9,0,6.77a12.88,12.88,0,0,0,11.69,0c3.22-1.86,3.26-4.9,0-6.77A12.91,12.91,0,0,0,344.26,604.91Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M379.38,605.1c-3.25,1.87-3.26,4.9,0,6.77a12.88,12.88,0,0,0,11.69,0c3.24-1.87,3.25-4.9,0-6.77A12.86,12.86,0,0,0,379.38,605.1Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.85,595c-3.24,1.87-3.26,4.9,0,6.77a12.88,12.88,0,0,0,11.69,0c3.22-1.86,3.26-4.9,0-6.77A12.91,12.91,0,0,0,396.85,595Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M432,595.19c-3.25,1.88-3.26,4.9,0,6.77a12.82,12.82,0,0,0,11.69,0c3.24-1.87,3.25-4.89,0-6.77A12.86,12.86,0,0,0,432,595.19Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M414.31,584.93c-3.25,1.87-3.26,4.9,0,6.77a12.86,12.86,0,0,0,11.68,0c3.25-1.87,3.26-4.9,0-6.77A12.86,12.86,0,0,0,414.31,584.93Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M379.58,625.44c-3.24,1.87-3.26,4.9,0,6.77a12.88,12.88,0,0,0,11.69,0c3.22-1.86,3.26-4.9,0-6.77A12.91,12.91,0,0,0,379.58,625.44Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M361.92,615.18c-3.24,1.87-3.26,4.89,0,6.77a12.88,12.88,0,0,0,11.69,0c3.22-1.87,3.26-4.9,0-6.77A12.85,12.85,0,0,0,361.92,615.18Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M397,615.36c-3.25,1.87-3.26,4.9,0,6.77a12.88,12.88,0,0,0,11.69,0c3.24-1.87,3.25-4.9,0-6.77A12.86,12.86,0,0,0,397,615.36Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M414.51,605.27c-3.24,1.87-3.26,4.9,0,6.77a12.88,12.88,0,0,0,11.69,0c3.22-1.86,3.26-4.9,0-6.77A12.91,12.91,0,0,0,414.51,605.27Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M414.63,572.2l-13.7-8-59.31-34.48-14.88-8.62-1-.59L306.3,531.77l-6.49,3.75L251,563.69,267,573l22.63,13.16,10.16,5.9,10.56,6.16,16.37,9.49,26,15.11L384.05,641l74.73-43.12Zm-157.18-8.15-1.79-1,8.15-4.72,1.8,1.05Zm67.14-40.84,1.79,1-.64.36-1.8-1Zm-2,1.18,1.79,1-1.38.8-1.8-1ZM319.81,526l1.83,1-1.39.8-1.8-1Zm-2.74,1.56,1.8,1.05-.65.39-1.79-1.05Zm-22.86,13.21,1.8,1-8.16,4.7-1.8-1Zm13.73,17.81-8.13,4.69-17.89,10.31-9.23-5.36,27.12-15.67,7.49-4.34L326.74,537l6.75-3.9,9.16,5.34.07.05-.07,0-15.91,9.18Zm48,53.12a11,11,0,0,1-4.34,1.31,12.52,12.52,0,0,1-7.36-1.31c-3.21-1.87-3.18-4.9.05-6.77a11.92,11.92,0,0,1,6.18-1.38,11.45,11.45,0,0,1,5.49,1.38C359.17,606.78,359.14,609.81,355.91,611.68Zm5.8-16.85a12.88,12.88,0,0,1,11.69,0c3.21,1.87,3.21,4.9,0,6.77a12.84,12.84,0,0,1-11.67,0C358.45,599.73,358.47,596.7,361.71,594.83ZM373.56,622a12.84,12.84,0,0,1-11.67,0c-3.24-1.88-3.21-4.9,0-6.78a13,13,0,0,1,11.7,0C376.82,617.05,376.79,620.07,373.56,622Zm5.64-37.2a12.84,12.84,0,0,1,11.67,0c3.24,1.87,3.18,4.9,0,6.77a12.9,12.9,0,0,1-11.7,0C375.92,589.65,375.94,586.62,379.2,584.75Zm.18,20.34a12.84,12.84,0,0,1,11.67,0c3.24,1.87,3.21,4.9,0,6.77a12.84,12.84,0,0,1-11.7,0C376.12,610,376.12,607,379.38,605.09Zm11.85,27.12a12.88,12.88,0,0,1-11.69,0c-3.21-1.88-3.21-4.9,0-6.78a12.93,12.93,0,0,1,11.67,0C394.49,627.31,394.47,630.36,391.23,632.21Zm5.42-57.54a12.82,12.82,0,0,1,11.69,0c3.21,1.87,3.18,4.9,0,6.77a12.84,12.84,0,0,1-11.67,0C393.39,579.57,393.41,576.54,396.65,574.67Zm.2,20.34a12.9,12.9,0,0,1,11.7,0c3.21,1.87,3.18,4.9-.05,6.77a12.9,12.9,0,0,1-11.7,0C393.59,599.91,393.62,596.88,396.85,595Zm11.83,27.11a12.78,12.78,0,0,1-11.67,0c-3.24-1.87-3.21-4.89,0-6.77a12.9,12.9,0,0,1,11.7,0C411.94,617.23,411.94,620.25,408.68,622.12Zm5.62-37.19a12.82,12.82,0,0,1,11.69,0c3.24,1.87,3.21,4.9,0,6.77a12.9,12.9,0,0,1-11.7,0C411,589.83,411.06,586.8,414.3,584.93ZM426.15,612a12.78,12.78,0,0,1-11.67,0c-3.24-1.87-3.21-4.9,0-6.77a13,13,0,0,1,11.7,0C429.43,607.14,429.38,610.17,426.15,612ZM443.62,602a12.9,12.9,0,0,1-11.7,0c-3.21-1.87-3.21-4.9.05-6.77a12.84,12.84,0,0,1,11.67,0C446.87,597.06,446.85,600.09,443.62,602Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-288",
    points: "241.62 598.18 231.05 592.03 231.05 535.51 237.54 531.77 238.54 548.18 239.19 558.55 241.62 598.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "283.98 622.78 257.99 607.67 257.99 521.12 272.87 529.74 273.89 538.41 273.89 538.51 281.69 603.52 282.82 612.99 283.98 622.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-290",
    points: "88 231.85 117.47 241.17 128.19 244.56 138.86 228.82 168.19 185.55 88 231.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "117.47 241.17 88 231.85 88.14 284.28 117.47 241.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "117.47 241.17 88.14 284.28 168.33 237.98 138.86 228.82 128.19 244.56 117.47 241.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "168.18 185.55 138.86 228.82 168.33 237.98 168.18 185.55"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-294",
    points: "88 231.85 85.04 230.14 85.19 282.57 88.14 284.28 88 231.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-295",
    points: "168.19 185.55 165.23 183.84 85.04 230.14 88 231.85 168.19 185.55"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "391.68 277.82 332.27 243.52 411.37 197.85 470.78 232.16 391.68 277.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M482.92,230.51l-13.28,9.81c-9.39-4.23-11.06-12.06-3.72-17.48s20.89-6.38,30.28-2.15c.7.32,1.35.65,2,1Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M482.92,230.51,503.06,235c-4.27,6.42-16.75,9.63-27.87,7.17a27.37,27.37,0,0,1-5.55-1.82Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M482.92,230.51l15.25-8.81c6.24,3.6,8.05,8.52,4.89,13.27Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M439.08,233.33l-2.23,1.29,38.95,22.49,2.23-1.29Zm-16.17,9.34,38.95,22.48,2.23-1.28-38.95-22.49Zm7-4,38.95,22.49,2.23-1.28-38.95-22.49Z",
    transform: "translate(-68.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-299",
    points: "391.68 280.45 391.68 277.82 470.78 232.16 470.78 234.78 391.68 280.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-300",
    points: "391.68 277.82 391.68 280.45 332.27 246.14 332.27 243.52 391.68 277.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-301",
    points: "557.55 140.39 726.99 238.22 726.99 150.68 557.55 52.85 557.55 140.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "704.97 201.65 714.93 219.79 695.01 208.28 704.97 201.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "685.04 147.37 695.01 208.28 675.08 196.78 685.04 147.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-290",
    points: "665.12 164.35 675.08 196.78 655.16 185.28 665.12 164.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "645.2 144.89 655.16 185.28 635.24 173.77 645.2 144.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "621 110.4 568.24 79.94 568.24 76.32 621 106.78 621 110.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "568.24 89.13 568.24 85.51 621 115.97 621 119.59 568.24 89.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "568.24 98.32 568.24 94.7 621 125.16 621 128.78 568.24 98.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "568.24 107.52 568.24 103.9 621 134.36 621 137.97 568.24 107.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "568.24 116.71 568.24 113.09 621 143.55 621 147.17 568.24 116.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "568.24 125.9 568.24 122.28 621 152.74 621 156.36 568.24 125.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "621 165.56 592.09 148.86 592.09 145.24 621 161.94 621 165.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.94,103.15a9.64,9.64,0,0,1-4.73-1.42L520.09,65.86c-5.38-3.1-9.74-10.66-9.72-16.85v-.59c0-3.26,1.19-5.73,3.32-7,1.89-1.09,4.27-1,6.76.12.16-2.92,1.31-5.14,3.29-6.28,2.15-1.23,4.9-1,7.75.64l14.91,8.61a6.78,6.78,0,0,1,3.15-5.07c2.15-1.23,4.9-1,7.75.64L565,44.59c5.24,3,9.51,10.25,9.72,16.33l2.34,1.35c5.38,3.11,9.74,10.67,9.72,16.85v1.37c3.84,3.78,6.47,9.58,6.46,14.32v.59c0,3.27-1.19,5.74-3.33,7A6,6,0,0,1,586.94,103.15ZM516.72,43.24a3.5,3.5,0,0,0-1.75.44c-1.31.75-2,2.44-2,4.75V49c0,5.27,3.85,12,8.44,14.62L583.49,99.5c2,1.18,3.88,1.4,5.18.64s2-2.43,2-4.74v-.59c0-4.25-2.47-9.52-6.05-12.83l-.41-.38V79.11c0-5.27-3.85-12-8.44-14.62l-3.61-2.08v-.74c0-5.52-3.86-12.21-8.45-14.86L556,42.34c-2-1.17-3.87-1.4-5.19-.64s-2,2.43-2,4.74v2.21l-1.92-.87-16.66-9.62c-2-1.17-3.86-1.4-5.18-.63s-2,2.43-2,4.74V46l-2.83-1.63A7.11,7.11,0,0,0,516.72,43.24Z",
    transform: "translate(-68.7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTechnology);
export default __webpack_public_path__ + "static/media/microsoft-technology.2eff2ed0e48f4cf4c5e70bde2f16a712.svg";
export { ForwardRef as ReactComponent };